{
  "translations": {
    "4Aces1KingString": "4 Aces and a King",
    "aboutArticleString": "About article",
    "aboutMFAQString": "About MFAQ",
    "aboutRepeatingTasksTitle": "About repeating tasks",
    "aboutString": "About {{name}}",
    "aboutToChangeString": "You're about to change {{count}} tasks.",
    "acceptActionString": "Accept",
    "acceptedString": "Accepted",
    "acceptIssueString": "Accept issue",
    "acesAndKingString": "4 Aces and a King",
    "acesAndKingWholeStoreOnlyString": "4 Aces and a King - WHOLE STORE ONLY",
    "activateRoomNameRequiredString": "To activate a room, it is required to provide a name",
    "activateRoomString": "Activate room",
    "activateScannerString": "Activate scanner",
    "activeString": "Active",
    "activeTeamString": "Active Team",
    "activity1String": "<b>Tap on notifications</b> to see all unread notifications.",
    "activity2String": "<b>Check all</b> unread messages.",
    "activityAreaString": "Activity area",
    "activityContentString": "Keep track of task changes or updates. ",
    "activityIngressString": "On the activity page you can view tasks that you've created. You can also see your teams tasks in progress, planned and completed or closed tasks.",
    "activityString": "Activity",
    "actorTypeSystem": "System",
    "addAnotherString": "Add another number",
    "addAnyLocalSafetyRequirementsToConsiderString": "Add any local safety requirements to consider",
    "addArticleAndQuantityInformationString": "Enter, per line, an article number (allowed formats 'XXXXXXXX', 'XXX.XXX.XX' 'XXX-XXX-XX') and optionally the quantity separated with a single space. If quantity is omitted it will be defaulted to 1. Examples: '123.456.78' or '12345678 3'",
    "addArticleNumberString": "Please enter a valid article number",
    "addArticlesString": "Add articles",
    "addArticlesToGroupString": "Add articles to group",
    "addArticleString": "Add article",
    "addChecklistItemString": "Add checklist item",
    "addCommentString": "Add comment",
    "addContactString": "Add store contact",
    "addCustomLocation": "+ Add \"{{code}}\" ",
    "addCustomLocationString": "Add custom location",
    "addDescriptionHeadlineString": "Add description",
    "addDescriptionPlainString": "Add description",
    "addDescriptionRequiredString": "Add description (required)",
    "addedCountUsersString": "Added {{count}} users.",
    "addedNewPhotoString": "Added new photo",
    "addImagesString": "Add images",
    "additionalString": "Type additional details",
    "addLinksString": "Add links",
    "addLocationString": "Add location",
    "addMediaString": "Add media",
    "addMoreImagesString": "Add more images",
    "addNearbyAddonsString": "Add nearby add-ons",
    "addNewOrUpdateFiltersString": "Either add new articles or update your filters",
    "addNewQuestionString": "Add new question",
    "addNewTagString": "Add new tag",
    "addNotesString": "Add notes",
    "addNoteString": "Add a note",
    "addNumbersString": "Add numbers",
    "addonInsightsDesktopBodyString": "Tip: You can save and bookmark your filters there. Learn more on the About page of the Fixa Dashboard. Click here to check it out.",
    "addonInsightsDesktopTitleString": "We see that you are accessing insights via a desktop. Therefore, we recommend using the Fixa Dashboard.",
    "addonInsightsString": "Add-on insights",
    "addonLocationString": "Location options",
    "addonOrderString": "Add-on order",
    "addonString": "Add-on order",
    "addonTitleString": "Pick & Refill",
    "addonTutorialContentString": "Learn how to create Add-on sales task",
    "addonTutorialString": "Create an Add-on task",
    "addonTutorialTitleTextString": "Create an Add-on sales (AOS) task",
    "addOrUpdateImagesString": "Add or update images",
    "addPhoneString": "Add your IKEA phone number",
    "addPhotoString": "Add photo",
    "addQuantityAfterArticleNumberString": "You can add quantity after the article number, separated by a space. For example: 123456 10",
    "addQuantityNumberString": "Please enter quantity between 1 and {{ maxQuantity }}",
    "addQuestionTitle": "Add customer question",
    "addRexCodeString": "Add design codes generated from REX and other planner/designer tools to import all articles.",
    "addRoomSettingsString": "Add Room settings",
    "addRoomsString": "Add rooms",
    "addSomethingString": "Add {{name}}",
    "addString": "Add",
    "addTeamString": "Add team",
    "addtitleHeadlineString": "Add task title",
    "addToGroupClarificationString": "The chosen articles will be added when the group is created.",
    "addToGroupString": "Add to group",
    "addToOrderString": "Add to order",
    "addTutorial1String": "Use the bottom navigation bar to got to “Create a task“ page and click on “Add-on order“",
    "addTutorial2String": "Scan or search for the product, check the stock and if there are any “Related tasks“ and press continue",
    "addTutorial3String": "Select existing store location or write a custom location for product to be refilled in",
    "addTutorial4String": "Enter the quantity of the product to refill",
    "addTutorial5String": "Assign task to the person/team who does the picking ",
    "addTutorial6String": "Check all information and edit if necessary ",
    "addTutorial7String": "Push the “done” button",
    "addTutorial8String": "Add the nearby products to the order when applicable by selecting the product and adding the quantities",
    "addUserString": "Add User",
    "addUserToTeamString": "Add User to {{ teamName }}",
    "adminCountryFilter": "Country",
    "adminRoleFilter": "Roles",
    "adminStoreFilter": "Store",
    "affectedQuantityString": "Affected quantity",
    "afternoonRoundString": "Afternoon round",
    "afternoonString": "Afternoon",
    "agoString": "ago",
    "aisleString": "Aisle",
    "alertsFilterTitleString": "Alerts",
    "allAlertsString": "All alerts",
    "allAreasString": "All areas",
    "allArticlesInGroupWillBeDeletedString": "All articles in the group will also be deleted. Any ongoing tasks for those articles will be closed. This can not be undone.",
    "allArticlesString": "All articles",
    "allChangesLostCloseString": "All changes will be lost. Are you sure you want to close?",
    "allClearedString": "All comments cleared",
    "allClosedInThisStore": "All closed in this store",
    "allClosedReasonsString": "All closed reasons",
    "allCloseReasonsString": "All closeed reasons",
    "allCompletedInStore": "All completed in this store",
    "allCompletedTasksString": "All completed tasks",
    "allDatesString": "All dates",
    "allDoneString": "All done!",
    "allEdsDatesString": "All EDS dates",
    "allFiltersString": "All filters",
    "allHFBs2String": "ALL HFB",
    "allHFBsString": "All departments",
    "allLocationsString": "All Locations",
    "allMarkethallString": "All Markethall locations",
    "allMediaPlacementsString": "All media placements",
    "allMediaString": "All media",
    "allMediaTypesString": "All media types",
    "allOngoingTasksWillBeClosedString": "Any ongoing tasks for those articles will be closed.",
    "allOtherLocationsString": "All Other Locations",
    "allPedsDatesString": "All past EDS dates",
    "allQuantityTypesString": "All quantity types",
    "allRoomsInactiveString": "No active room settings available. Please go to Fixa Admin to activate.",
    "allRoundsString": "All rounds",
    "allSelectedArticlesWillBeDeletedIncludingGroupsString": "All selected articles will be deleted. Including articles in groups.",
    "allSelectedArticlesWillBeDeletedString": "All selected articles will be deleted. Any ongoing tasks for those articles will be closed. This can not be undone.",
    "allShowroomString": "All Showroom locations",
    "allStores": "All stores",
    "allString": "All",
    "allTaskTypesString": "All task types",
    "allTeams": "All teams",
    "allTeamsInString": "All Teams in",
    "allTeamsString": "All Teams",
    "allUnfinishedTasksInSeriesString": "All unfinished tasks in series",
    "allUsers": "All users",
    "allUsersInString": "All Users in",
    "allUsersString": "All Users",
    "allWarehouseLocationsString": "All Warehouse Locations",
    "alphabeticalOrderAZString": "Alphabetical order A-Z",
    "alphabeticalOrderZAString": "Alphabetical order Z-A",
    "alreadyAskedString": "Already asked",
    "amountMoreString": "{{ count }} more",
    "amountSettingsTitleString": "Settings",
    "amountTitleString": "Amount",
    "andString": "and",
    "announcementDashboardPara1": "Our new and updated version of Fixa store operations dashboard is live!\n\nWith the updated dashboard, you have a better overview of <b>tasks, add-on insights and product quality reports!</b>\n\nThe new dashboard gives you better understanding of how add-on locations are performing in terms of completed refills, articles and estimated turnover!",
    "announcementDashboardPara2": "Request access to our dashboard by visiting <link /> and search for <b>‘Fixa’</b>. Select the first option and fill it in. Remember to use your IKEA email!\n\nIf you already had access to our dashboard since before, you don’t need to do anything. Simply visit the dashboard and you will see the new release.\n\nIf you have any questions, provide feedback, or need help with access - please reach out to:\nfixa.support@ingka.ikea.com",
    "announcementDashboardSubHeader": "How can I access it?",
    "announcementDashboardTitle": "Fixa dashboard is live!",
    "announcementsTitleString": "Announcements",
    "appBarBackButtonAriaString": "Press this button to go back.",
    "appBasics1String": "Use the Home screen to <b>change your team</b>, access your <b>profile</b>, follow up on <b>Add-on</b> sales, and <b>navigate</b> to other parts of the app.",
    "appBasics1String_new": "Profile has overall app settings. For example: Change team, Notifications settings and Store contacts.",
    "appBasics2String": "<b>Notification settings</b> can be changed from your profile. Here you can adjust them to your preference.",
    "appBasics3String": "<b>Enable all notifications</b> at once or select specific notifications which you'd like to receive.",
    "appBasics4String": "Navigate to the <b>Create a task</b> page by tapping on the icon highlighted in yellow. From here you'll be able to create a <b>Product issue</b>, <b>Add-on order</b> or <b>Custom task</b>.",
    "appBasics4String_new": "Navigate to the menu to see a list of all Fixa features. The order of the list will be a reflection of the features you use most. You can initiate tasks from here.",
    "appBasics5String": "Alternatively, <b>create a task</b> by navigating to the <b>scan and search screen</b>. From here, you can either scan an article or type the article name or number in the <b>search input field</b>.",
    "appBasics6String": "To <b>edit a task</b>, look for the <b>3 horizontal dots</b> icon to see available options.",
    "appBasicsContentString": "Get up to speed with the main app functionalities.",
    "appBasicsString": "App basics",
    "appliedFiltersString": "Applied filters",
    "applyChangesToString": "Apply changes to",
    "applyFiltersString": "Apply filters",
    "applyNTasksString": "Apply for {{count}} task",
    "applyNTasksString_plural": "Apply for {{count}} tasks",
    "applyNTasksString_other": "Apply for {{count}} tasks",
    "applyString": "Apply",
    "applyString2_one": "Apply ({{count}})",
    "applyString2_other": "Apply ({{count}})",
    "applyString2_zero": "Apply",
    "applyString_one": "Apply({{count}})",
    "applyString_other": "Apply({{count}})",
    "applyString_zero": "Apply",
    "appSupportString": "App support",
    "appSwitcherString": "App switcher",
    "aprilString": "April",
    "areaHFBLocationInStoreString": "Area / HFB location in store",
    "areaString": "Area",
    "areWeCreatingValueString": "This helps us understand what value we create or where to improve. Thank you ⭐️",
    "areYouSureCreateRefillString": "Are you sure you want to create a new refill task?",
    "areYouSureYouWantToDeleteString": "Are you sure you want to delete",
    "areYouSureYouWantToDeleteThisCommentString": "Are you sure you want to delete this comment?",
    "areYouSureYouWantToLeave": "Are you sure you want to leave this page?",
    "articleAlreadyExistsString": "Article already exists",
    "articleAlreadyInTestbuyString": "Article already in Test buy. Please select another one.",
    "articleDeletedString": "Article deleted",
    "articleDoesNotExistInRoomSettingString": "Article {{ article }} does not exist in any room setting.",
    "articleExistsQuantityUpdatedString": "Articles exist, and their quantities have been updated.",
    "articleHFBInMediaString": "Article HFB in media",
    "articleHFBString": "Article HFB",
    "articleInsightsString": "Article Ranking",
    "articleIsPartOfLocalCombinationString": "Article is part of a local combination",
    "articleListString": "Article list",
    "articleNotAddedString": "This article cannot be added. Please pick a different one.",
    "articleNumbersCopiedToClipboardString": "Article numbers copied to clipboard!",
    "articlePriceMissingString": "Article is missing price and/or currency information. Please try again later.",
    "articleRemovedInTaskDescriptionString": "Article has been removed from media",
    "articleRemovedString": "Article removed",
    "articleReplacedString": "Article replaced",
    "articlesAddedExistingArticlesQuantitiesUpdatedString": "Articles added, and existing article quantities have been updated.",
    "articlesAddedString": "Articles added",
    "articlesAddedSuccessfullyString": "Articles added successfully",
    "articlesAreDamagedString": "Articles are damaged",
    "articlesAreMissingFromMediaString": "Articles are missing from media",
    "articlesAvailableForHfbString": "For {{ hfb }} there were only {{ count }} articles available for the selected Test buy.",
    "articlesAvailableString": "{{ count }} articles available",
    "articlesDeletedString": "Articles deleted",
    "articleSelectedString": "Article selected",
    "articlesInAreaString": "{{ count }} articles in {{ area }}",
    "articlesLowerCaseString": "articles",
    "articlesNeedNewPTagsString": "Articles need new P-tags",
    "articlesNeedToBeRemovedString": "Articles need to be removed",
    "articlesNotInGroupsString": "Articles not in groups",
    "articlesOnlyInGroupsString": "Articles only in groups",
    "articlesRemovedInTaskDescriptionString": "All articles have been removed from media",
    "articlesRemovedString": "Articles removed",
    "articlesSelectedCountString": "{{ count }} Articles selected",
    "articlesSelectedString": "articles selected",
    "articlesString": "Articles",
    "articlesTestBoughtString": "Articles test bought",
    "articlesTestedString": "Articles tested",
    "articleString": "Article",
    "articlesWithNoOngoingTasksString": "Articles with no ongoing tasks",
    "articlesWithOngoingTasksString": "Articles with ongoing tasks",
    "artileNumberCopiedToCliboardString": "Article number copied to clipboard!",
    "asisString": "Asis",
    "askFixaAllEDSArticlesString": "What are the EDS articles?",
    "askFixaAnythingString": "Ask anything",
    "askFixaArticlesNeedingActionString": "List all articles that need action",
    "askFixaAssistantString": "assistant",
    "askFixaEDSReachingThisMonthString": "What EDS articles reach past EDS this month?",
    "askFixaEDSReachingThisWeekString": "What EDS articles are reaching past EDS this week?",
    "askFixaEmptyResponseString": "I couldn’t find any information for your request. Please try rephrasing your question or providing more details.",
    "askFixaHighPriorityArticlesString": "What articles need high priority attention?",
    "askFixaInStockCountString": "In stock count",
    "askFixaOutOfScopeQuestionAnswerString": "That's not something I can help with, but a FIXA super user should be able to point you in the right direction!",
    "askFixaOverallStatusString": "What's the overall status?",
    "askFixaPastEDSArticlesPaginatedString": "Show 100 past EDS articles",
    "askFixaPastEDSArticlesString": "What articles have past EDS?",
    "askFixaPriorityString": "Priority",
    "askFixaQuantityString": "Quantity",
    "askFixaSalesStopArticlesString": "What articles have a sales stop?",
    "askFixaThinkingString": "Thinking...",
    "askFixaTimeoutString": "The request is taking longer than expected. Please try again in a moment.",
    "askFixaTooBigDatasetAnswerString": "Your request is too large for me to process right now. Could you split it into smaller parts and try again? For example, ask about one alert at a time.",
    "askFixaUrgentArticlesString": "Show 5 urgent articles",
    "askFixaZeroStockCountString": "Zero stock count",
    "askMeLaterString": "Ask me later",
    "assemblyAndDocsString": "Assembly and documents",
    "assemblyDocString": "Assembly documents",
    "assemblyString": "Assembly Instructions",
    "assigned2String": "Assigned to",
    "assignedRecentlyString": "Assigned recently",
    "assignedTaskToString": "assigned task to {{ name }}",
    "assignedTaskToTeamString": "{{ assigner }} assigned a task to {{ team }}",
    "assignedTaskToYouString": "{{ assigner }} assigned a task to you",
    "assignedToColonString": "Assigned to:",
    "assignedToString": "Owner",
    "assignedToTaskFilterString": "Assigned to",
    "assignedToWithNameString": "Assigned to {{ name }}.",
    "assigningTitleString": "Assigning to",
    "assigningToString": "Assigning to {{ assignee }}",
    "assignString": "Assign to",
    "assignToTeamString": "Assign to team",
    "assignToUserString": "Assign to user",
    "atkomstCoworkerString": "Co-worker",
    "atkomstStoresDisclaimerString": "You can only see stores you have been assigned a role to. If you do not have a store in the list, you need to request a role to Fixa in ",
    "atkomstSuperUserString": "Super User",
    "atString": "At",
    "attachArticles": "Attach articles",
    "attachArticleString": "Attach article",
    "attachFilesString": "Attach files",
    "attachMoreFilesString": "Attach more files",
    "attemptingToReconnectString": "Attempting to reconnect {{seconds}}",
    "augustString": "August",
    "availableArticlesForHfbString": "Available articles for {{hfb}}",
    "availableAtCashlineString": "Available at Cashline",
    "availableAtMarkethallOTWString": "Available at Markethall OTW",
    "availableAtMarkethallOWString": "Available at Markethall OW",
    "availableAtShowroomOTWString": "Available at Showroow OTW",
    "availableAtShowroomOWString": "Available at Showroow OW",
    "availableAtShowroomString": "Available at Showroom OW",
    "avgColonString": "AVG:",
    "awayBoxContentString": "All add-ons from {{hfb}}, sold outside of {{hfb}}.",
    "awayBoxTitleString": "in Away",
    "awayDepartmentString": "Away",
    "awayExplanationString": "See how an add-on article is performing elsewhere in the store.<br /><br />This helps you plan if you should change the location of that article to another department or location.",
    "awaytitleString": "Away",
    "backendOperationFailedString": "Call to database failed. No data was saved. Please try again later.",
    "backString": "Go back online to",
    "backToLoginString": "Back to login",
    "backToSearch": "Back to {{ initialPageTitle }}",
    "backToStores": "Back to All stores",
    "backupForProductString": "Backup for product",
    "backupProductOneString": "BACKUP PRODUCT 1",
    "backupProductString": "Backup product",
    "backupProductTwoString": "BACKUP PRODUCT 2",
    "bagTrolleyString": "Bag trolley",
    "bathroomString": "Bathroom",
    "bedroomString": "Bedroom",
    "beforeYouLeaveString": "Before you leave...",
    "bestString": "Best",
    "binString": "Bin",
    "blankCanvasString": "Blank canvas",
    "blueBagString": "Blue bag (Shop & Go)",
    "blueBagToolString": "Blue bag",
    "breathtakingItemAceString": "Ace 3: BTI",
    "BTIString": "Ace 3: BTI",
    "bulkEditTasks": "Bulk edit tasks",
    "businessQT": "Business",
    "byGridcodeString": "Grid code",
    "byNameString": "By name",
    "byPriorityString": "By priority",
    "calculatedString": "Based on refills",
    "cameraScanString": "Camera scan",
    "cameraString": "Camera",
    "cameraUnavailableTryToSearch": "Camera is unavailable, try to search",
    "cancelScheduleTaskString": "Cancel schedule task",
    "cancelString": "Cancel",
    "canNotBeUndoneString": "This can not be undone.",
    "cannotCreateTaskString": "Sorry, a task cannot be created for this article right now.",
    "cantChangeStoreString": "You can not make changes to this store",
    "cantFindAnything": "Can't find anything for this time period.",
    "cantUpvoteInThePastString": "Can't upvote in the past",
    "cantUpvoteInWholeStore": "Can't upvote when whole store is selected",
    "capitalCaseAddonInsightsString": "Add-on Insights",
    "capitalCaseCustomString": "Custom Task",
    "capitalCaseLaunchMediaString": "Launch Media",
    "capitalCaseMediaMaintenanceString": "Media Maintenance",
    "capitalCaseMultiOrderAddOnsString": "Multi-Order of Add-ons",
    "capitalCaseProductQualityReportString": "Product Quality Report",
    "capitalCaseTeamManagementString": "Team Management",
    "capitalCaseTestBuyString": "Test Buy",
    "capitalisedTeamNameString": "Team Name",
    "careString": "Care instructions",
    "cartsQT": "Carts",
    "cashlineString": "Cashline",
    "cddCustomLocationString": "Add custom location",
    "changeArticleString": "Change article",
    "changeMediaTypeString": "Change media type?",
    "changeOrConfirmQuantityForEachMediaString": "Change or confirm the needed quantity for each media.",
    "changeProductInString": "Change product in {{ room_name }}",
    "changeProductString": "Change product",
    "changeString": "Change team",
    "changeTeamsLaterString": "You can change teams later",
    "changeTeamString": "Change",
    "changeToCashlineString": "Change to cashline",
    "changeToDifferentArticleString": "Change to different article",
    "changeWith2String": "Change with",
    "changeWithString": "Change with...",
    "checklistString": "Checklist",
    "checklistToFixString": "Checklist to fix",
    "checkString": "Check your connection",
    "childrenRoomString": "Children room",
    "chooseAnOptionString": "Choose an option",
    "chooseAssigneeString": "Choose assignee",
    "chooseColorString": "Choose color",
    "chooseSizeString": "Choose size",
    "chooseTeamString": "Choose team",
    "ciEnvironmentString": "CI ENVIRONMENT",
    "clearAllString": "Clear All",
    "clearFiltersString": "Clear filters",
    "clearHistoryString": "Clear history",
    "clearSearchString": "Clear search",
    "clearString": "Clear all",
    "closeActionString": "Close",
    "closeAllUnfinishedTasksSeriesString": "Close all unfinished tasks in series",
    "closeAllUnfinishedTasksString": "Close all unfinished tasks",
    "closeAlreadyResolvedString": "Already resolved",
    "closeAndProceedString": "Close and proceed",
    "closedAndCompleted": "Closed and completed",
    "closedByMyTeamString": "Closed by my team",
    "closedByString": "closed by",
    "closedByUppercaseString": "Closed by",
    "closeDeleteArticleString": "Close delete article",
    "closedFirstUppercaseString": "Closed",
    "closeDiscoverNowString": "Close discover now",
    "closedLowerString": "closed",
    "closedNTasksString": "{{count}} task closed",
    "closedNTasksString_plural": "{{count}} tasks closed",
    "closedNTasksString_other": "{{count}} tasks closed",
    "closedReasonString": "Closed reason",
    "closedString": "You closed the task",
    "closedTask": "CLOSED",
    "closedTaskDueTo1String": "Closed task due to {{ translationParams.0 }}",
    "closedTaskDueToString": "Closed task due to {{ params.0 }}",
    "closedTheTaskDueToString": "Closed the task due to {{ reason }}",
    "closeDuplicateString": "Duplicated task",
    "closedWithinLastWeekString": "Closed within the last week",
    "closeErrorMessage": "Trouble closing task. Retrying once.",
    "closeIncorrectString": "Incorrect",
    "closeInvalidString": "Invalid",
    "closeIssueString": "Close issue",
    "closeNotInStockString": "Not in stock",
    "closeOtherString": "Other",
    "closeString": "Close task",
    "closeTasksString": "Close tasks",
    "colorAndNcsString": "Color and NCS #",
    "colorMaterialString": "Color / Material",
    "colorString": "Color",
    "commentsCountString": "Comments ({{ count }})",
    "commonRetailSolutionsString": "Common Retail Solutions",
    "completd3String": "Completed",
    "complete2String": "Complete",
    "completeButton": "Complete",
    "completeCriteriaToFinishString": "Complete this criterion to finish the checklist",
    "completed2String": "You completed the task.",
    "completedAndAssignedToTeam": "completed picking & assigned task to the {{ team }} team",
    "completedByMyTeamString": "Completed by my team",
    "completedInstructionString": "COMPLETED",
    "completedLowerString": "completed",
    "completedPickingAndTaskAssignedToPerson": "completed picking & assigned task to {{ name }}",
    "completedPickingString": "completed picking",
    "completedString": "You completed",
    "completedTagString": "Completed",
    "completedTask": "COMPLETED",
    "completedTaskString": "Completed task",
    "completedTheTaskString": "Completed the task",
    "completedWithChangesString": "Completed with changes",
    "completedWithChangesTagString": "Completed with changes",
    "completeMultiOrderAddOnsString": "Complete multi-order ({{ count }})",
    "completePickingButton2String": "Complete picking",
    "completePickingButtonString": "Complete picking...",
    "completePickingChangesButton2String": "Complete picking with changes",
    "completePickingChangesButtonString": "Complete picking with changes...",
    "completePickingString": "Complete picking only",
    "completePickingWithChangesString": "Complete picking with changes",
    "completeRefillWithChangesString": "Complete refill with changes",
    "completeString": "Complete",
    "completeTasksString": "Complete tasks",
    "completeTaskString": "Complete task",
    "completeTasksWithCountString": "Assign completed tasks ({{ count }})",
    "completeWithChangesButton": "Complete with changes",
    "completeWithChangesString": "Complete with changes",
    "confirmCloseString": "Confirm close",
    "confirmDetailsString": "Confirm details",
    "confirmPickingChangesString": "Confirm picking details",
    "confirmPickingRefillingString": "Confirm pick & refill details",
    "confirmPickingString": "Confirm the picking location",
    "confirmPinCodeString": "Confirm PIN code.",
    "confirmString": "Confirm",
    "contactStoreSuperUserString": "Contact your store or country super user for team and store related questions",
    "continue2String": "Continue",
    "continueString": "continue",
    "continueTestbuyString": "Continue Test buy",
    "continueToMultiOrderAddonsString": "Continue to multi-order Add-ons",
    "contributionPieces": "Contribution",
    "copiedString": "Copied",
    "copyAllArticleNumbersString": "Copy all article numbers",
    "copyUserEmailString": "Copy user email",
    "couldNotAddArticleString": "Could not add article",
    "couldNotAddImageString": "Could not add {{imageName}}. Please try another image.",
    "couldNotCreateRoomTryAgainString": "Could not create room. Please try again later.",
    "couldNotLoadArticlesString": "Not able to load articles at the moment - please try again later",
    "couldNotLoadDataString": "Couldn't load stock data",
    "couldNotLoadMediasString": "Not able to load medias at the moment - please try again later",
    "couldNotUpdateRoomTryAgainString": "Could not update room. Please try again later.",
    "couldNotUseThisArticleString": "Could not use this article, please select another one.",
    "countArticlesString": "{{ count }} article",
    "countArticlesString_plural": "{{ count }} articles",
    "countArticlesString_other": "{{ count }} articles",
    "countMediaString": "{{ count }} media",
    "countRoomSettingsString": "{{ count }} room setting",
    "countRoomSettingsString_plural": "{{ count }} room settings",
    "countRoomSettingsString_other": "{{ count }} room settings",
    "countRoomsString": "{{ count }} room ",
    "countRoomsString_other": "{{ count }} rooms",
    "countrySuperUsersDescription": "Can help manage user profiles across stores",
    "countrySuperusersString": "Country Super users",
    "countrySuperuserString": "Country Super user",
    "countTasksSelectedString": "{{count}} task selected",
    "countTasksSelectedString_plural": "{{count}} tasks selected",
    "countTasksSelectedString_other": "{{count}} tasks selected",
    "countTotalPiecesString": "{{ count }} pieces in total",
    "countTotalPiecesString_one": "{{ count }} piece in total",
    "countTotalPiecesString_other": "{{ count }} pieces in total",
    "countTotalPiecesString_zero": "No pieces",
    "coworkerHubUnSupportedString": "If you're visiting from Co-worker Hub, some of Fixa’s functionality may not work. Please access Fixa through the app library or via a direct link in a browser. If Fixa is not available in the app library, please submit a NowIT ticket.",
    "coworkersString": "Co-workers",
    "coworkerString": "Coworker",
    "create2String": "Create a task",
    "create3String": "create a task",
    "create4String": "Create",
    "createACustomString": "Create a Custom task",
    "createAddonTaskString": "create an add-on task!",
    "createAProductIssueString": "Create a Product issue task",
    "createChecklistString": "Create checklist",
    "createCustomLocationString": "Create Custom Location",
    "createdAndAssignedTaskToName": "created & assigned task to {{ name }}",
    "createdAndAssignedTaskToNameString": "Created & assigned task to {{ name }}",
    "createdAndAssignedTaskToString": "Created and assigned task to {{ params.0 }}",
    "createdAndAssignedToTeam": "created & assigned task to the {{ team }} team",
    "createdByMeString": "Created by me",
    "createdByString": "Created by",
    "createdString": "Created",
    "createdTheTaskString": "created the task",
    "createFollowUpTaskString": "Create follow-up task",
    "createFollowUpTaskWarning": "You need to create a follow up task",
    "createGroupString": "Create group",
    "createMediaString": "Create media",
    "createModifyTasksString": "Create and modify tasks",
    "createMoreAddonOrdersInAreaString": "Create more add-on orders in the area?",
    "createMultiOrderAddOnsString": "Create multi-order ({{count}})",
    "createNameString": "Create {{name}}",
    "createNewQuestionString": "Create new question",
    "createNewString": "Create new",
    "createOrderString": "Create task",
    "createOrderString_plural": "Create {{ count }} tasks",
    "createOrderString_other": "Create {{ count }} tasks",
    "createProdTask": "Create a task for this product",
    "createProductIsuueString": "Create Product Issue",
    "createPTagPrintListString": "Copy article numbers for P-tag",
    "createRepeatingTaskString": "Create a repeating task",
    "createRoomSettingsString": "Create room settings",
    "createShortString": "Create",
    "createString": "Create task",
    "createTaskLinkString": "Add Task",
    "createTaskString": "Create a task",
    "createTestbuyString": "Create Test buy",
    "createYourCodeString": "Create your personal code",
    "creatingTasks01String": "Navigate to the <b>Create a task</b> page by tapping on the icon highlighted in yellow. Tap on <b>Add-on order</b> to start a refill request for an add-on article.",
    "creatingTasks02String": "<b>Search</b> for an article by typing in its <b>article number</b> or name and select the article from the search results.",
    "creatingTasks03String": "Here you can <b>check</b> the <b>stock</b> figures as well as if there are any <b>related tasks</b> existing for the article. You will be asked to add the <b>refill location</b> on the next page after you tap on the <b>Continue</b> button.",
    "creatingTasks04String": "Double check that all the data is correct. The <b>picking location</b> is set to the article's <b>primary (P) location</b>, but you can always change it.",
    "creatingTasks05String": "<b>Mark as complete</b> if you pick and <b>refill the add-on</b> right away. This keeps the add-on <b>insights</b> relevant and updated.",
    "creatingTasks06String": "<b>When applicable</b>, you will see other <b>nearby add-ons</b>, which have a refill location close by. <b>Tap Add to order</b> on the article and request quantity to refill.<br/><br/><b>Note:</b> You'll need to have refilled the location within the last 21 days for it to show up.",
    "creatingTasks07String": "You can create a <b>Product issue</b> task when a product needs <b>fixing</b>.",
    "creatingTasks08String": "<b>Select a product issue</b> from the list or tap on <b>Other</b> to add a <b>custom product issue</b>.",
    "creatingTasks09bString": "By tapping on <b>schedule task</b> you can set the task <b>to repeat</b> or <b>plan</b> it for the future.",
    "creatingTasks09String": "<b>Create a custom task</b> for anything that is <b>not related</b> to a specific article, and doesn't fit a <b>Product Issue</b> task or <b>Add-on order</b>.",
    "creatingTasks10String": "You can <b>manage recurring tasks</b> by navigating to <b>Task list</b> and selecting the <b>Activity tab</b>. From here you can view and edit <b>Planned tasks</b>.",
    "creatingTasksContentString": "Explore how to create Add-on tasks and other types of tasks.",
    "creatingTasksString": "Creating tasks",
    "criteraFailedString": "criteria failed",
    "criteriaFailedString": "Article failed {{failedCriteria}}/{{maxCriteria}} criteria",
    "currentNameString": "Current name",
    "currentSalesLocationsString": "Current sales locations",
    "currentStoreString": "Current store",
    "currentTertialString": "Current tertial",
    "curtainAddedString": "Got it. Your task has been added to the list.",
    "curtainRefilledString": "Your refill has been registered.",
    "curtainUpdateString": "Got it. Your task was updated.",
    "curtainViewString": "View",
    "customerCameToolString": "Customer came with this tool",
    "customerLeftToolString": "Customer left with this tool",
    "customerQuestionsString": "Customer MFAQ",
    "customerTookToolString": "Customer took this tool",
    "customInsightsPeriod": "Custom",
    "customInsightsPeriodGraphOptions": "Graph options",
    "customInsightsPeriodShowDays": "Show days",
    "customInsightsPeriodShowWeeks": "Show weeks",
    "customLocationInformationString": "Custom location information",
    "customLocationNamingGuidelinesCashline": "Cashline",
    "customLocationNamingGuidelinesHfbDigits": "The digits of the HFB",
    "customLocationNamingGuidelinesHowShouldTheLocationBeNamed": "How should the location be named?",
    "customLocationNamingGuidelinesInTheEnd": "In the end, you might have something like this:",
    "customLocationNamingGuidelinesLastPart": "The last part could be defined by the closest grid code in the ceiling, for example:",
    "customLocationNamingGuidelinesLocationNameStart": "The location name should start with one of these letters:",
    "customLocationNamingGuidelinesMarketHall": "Market hall",
    "customLocationNamingGuidelinesNextPart": "The next part should be defined by the area that the location is in, either one of these:",
    "customLocationNamingGuidelinesNoGridCode": "Don’t have a grid code? Feel free to fill in whatever you want to help define the sales location.",
    "customLocationNamingGuidelinesOpenWallet": "Open the wallet",
    "customLocationNamingGuidelinesOther": "Other",
    "customLocationNamingGuidelinesRefillMap": "Which will help us map the refill to the right location in the add-on follow-up:",
    "customLocationNamingGuidelinesRestaurant": "Restaurant",
    "customLocationNamingGuidelinesShowroom": "Showroom",
    "customLocationNamingGuidelinesThatsWhyItMatters": "By following the naming conventions, you contribute to better follow-ups.<br /><br />The bigger variety of sales locations names - the harder it is for us to map and group areas, for add-on insights follow-up.",
    "customLocationNamingGuidelinesTheNamingShouldAdhere": "The naming should stay as close as possible to the naming convention. There could be exceptions for your store unit.",
    "customLocationNamingGuidelinesTitle": "Naming conventions",
    "customLocationNamingGuidelinesWhyDoesThisMatter": "Why does it matter?",
    "customLocationsMessageString": "Custom locations are available for the selected article and will be deleted automatically after 28 days if it’s not used.",
    "customLocationsOnlyForFoodString": "Custom locations should only be created for Food articles.",
    "customLocationsString": "Custom locations",
    "customLocationString": "Custom location",
    "customPeriodString": "Custom",
    "customSalesLocationsString": "Custom sales locations",
    "customString": "Custom task",
    "customTasksString": "Custom tasks",
    "customTestBuyAndWholeStoreChosenErrorString": "You cannot create a custom/random test buy for the whole store. Please select a specific HFB.",
    "customTitlePlaceholderString": "Water plant, plan team events...",
    "customTitleString": "Custom",
    "dailyMaintenanceString": "Daily maintenance",
    "dailyRepeatingTaskSummaryText": "The task is scheduled to repeat once everyday starting <b>{{start}}</b> until <b>{{end}}</b>",
    "dailyRepeatString": "Every day",
    "dailyString": "Daily",
    "dashboardString": "Fixa Dashboard",
    "dashComLinkClarification": "Then the Fixa Dashboard is just what you need!",
    "dashComLinkHeadline": "Want to make data-driven decisions?",
    "dashComModalAbout": "About Fixa Dashboard",
    "dashComModalAccessHeadline": "Sounds great, how can I access it?",
    "dashComModalBenefits": "So whether you are looking into how many tasks have been completed in your store, or comparing add-on refills between other stores or markets - <b>Fixa Dashboard</b> is the right place!",
    "dashComModalFeedback": "If you have any questions, provide feedback, or need help with access - please reach out to:",
    "dashComModalFollowUp": "The Fixa dashboard is for anyone who wants to follow-up on data based on the usage of the Fixa app.",
    "dashComModalRequestAccess": "Request access to our dashboard by visiting:",
    "dashComModalStartToday": "Start using Fixa Dashboard Today",
    "dashComModalVisitDashboard": "If you already had access to our dashboard since before. Simply visit the dashboard:",
    "dashComModalVisualize": "You can get <b>graphs and tables</b> visualising the data. There is also more data about <b>tasks, add-on performance, product quality reports and product issue</b> - more to come!",
    "dataSinceString": "Data since",
    "dateCreatedString": "Date created",
    "dateFormatIsString": "Date format is YYYY-MM-DD",
    "dateStampString": "Date stamp",
    "dateString": "Date",
    "daysAgoString": "days ago",
    "daysOverdueString": "{{daysOverdue}} days overdue",
    "daysString": "days",
    "dayString": "day",
    "decemberString": "December",
    "declinedString": "Declined",
    "declineString": "Decline",
    "decreaseQuantityString": "Decrease",
    "decreaseValueString": "Decrease value",
    "defectedProductLocationString": "Where are the defect products located?",
    "deleteActionChangeText1": "Tasks assigned to this user will be re-assigned to the team.",
    "deleteActionChangeText2": "Tasks and comments created by this user will be marked as being from a “Deleted user”.",
    "deleteActionChangeTitle": "This will change",
    "deleteActionText": "Personal information, such as name, username and phone number.",
    "deleteActionTitle": "This will be deleted",
    "deleteArticleImageWarningString": "The item selected for removal may be referenced in certain media assets. To maintain data integrity, please re-process these images to ensure they reflect the current system state.",
    "deleteArticleInGroupSetTasksClosedString": "All ongoing tasks for this article in this group will be closed.",
    "deleteArticleSetTasksClosedString": "All ongoing tasks for this article in this {{ mediaName }}, whether it is in a group or not, will be closed.",
    "deleteArticleString": "Delete article",
    "deletedArticlesString": "Deleted articles",
    "deletedUserString": "Deleted user",
    "deleteGroupAndAllArticlesString": "Delete group and all articles in it",
    "deleteGroupString": "Delete group",
    "deleteImagesString": "Delete selected images",
    "deleteImageString": "Delete selected image",
    "deleteLastTeamString": "Delete last team",
    "deleteMediaString": "Delete media",
    "deleteMediaTasksClosedString": "All ongoing tasks in the media will be closed.",
    "deleteNameString": "Delete {{ name }}",
    "deleteRoomSettingTasksClosedString": "All ongoing tasks in the room setting will be closed.",
    "deleteRoomString": "Delete room setting",
    "deleteSelectedArticlesString": "Delete selected articles",
    "deleteString": "Delete",
    "deleteTeamActionTextString": "All users and tasks will be transferred to new team selected",
    "deleteTeamActionTitle": "This will change",
    "deleteTeamString": "Delete team",
    "deleteTeamTasksPromptCloseOptionString": "Close all tasks assigned to the team",
    "deleteTeamTasksPromptReassignOptionString": "Reassign all tasks to a different team",
    "deleteTeamTasksPromptSubtitleString": "Please decide what to do with the tasks before deleting the team",
    "deleteTeamTasksPromptTitleSingleString": "There is 1 task assigned to this team",
    "deleteTeamTasksPromptTitleString": "There are {{ count }} tasks assigned to this team",
    "deleteUserTitle": "Delete user",
    "deleteUserUndoWarning": "You cannot undo this action.",
    "deletingPQTeamInstructionsString": "Deleting Product Quality team is disabled. To delete this Product Quality team, first change it to a non Product Quality team, create another Product Quality team and then proceed to delete this one. You can transfer all tasks to the newly created Product Quality team.",
    "deletingPQTeamTitleString": "Deleting Product Quality team",
    "demoEnvironmentString": "Demo environment",
    "departmentsString": "Departments",
    "describeProblemString": "Describe the problem",
    "describeTheProblemString": "Describe the problem:",
    "description3String": "Add a description",
    "description4String": "Description",
    "descriptionAddString": "Add a description",
    "descriptionAway2String": "Add-ons that belong to the selected HFB, but located and refilled outside of the selected HFB.",
    "descriptionAwayString": "All add-ons from the selected HFB sold anywhere outside that selected HFB.",
    "descriptionHome2String": "All locations where add-ons have been refilled in the selected HFB.",
    "descriptionHomeString": "All add-ons sold on the selected HFB. ",
    "designerString": "Designer",
    "detailsAndSizingString": "Details and sizing",
    "detailsBasicString": "Details",
    "detailsString": "Details and sizing",
    "devEnvironmentString": "DEVELOPMENT ENVIRONMENT",
    "differentMediaString": "different media",
    "dimensionsString": "Dimensions",
    "directionsQT": "Direction",
    "directTakeawayDescriptionString": "This room setting has a selection of products for direct takeaway, based on common seasonal activities. This selection of products reflects the look and feel of the room. It will inspire visitors and stimulate impulse buying behaviour.",
    "directTakeawayString": "Direct takeaway",
    "dirtyProductString": "Dirty product",
    "disclaimerString": "Only the latest version of the documents is available for download. This means that there maybe a difference in this version and the printed version.",
    "discoverNowString": "Discover now",
    "dismissNotificationString": "Dismiss notification",
    "dismissString": "Dismiss",
    "divisionOthers": "Others",
    "divisionSelfServe": "Self serve",
    "divisionsMarketHall": "Markethall",
    "divisionsWareHouse": "Warehouse",
    "divsionsShowRoomString": "Show room",
    "doesNotRepeatString": "Does not repeat",
    "doesThisWorkForYouString": "Does this work for you?",
    "doneExclamationString": "Done!",
    "doneString": "Done",
    "dontScheduleOrRepeatTaskString": "Don’t schedule or repeat task",
    "dontScheduleTaskString": "Don’t schedule task",
    "downloadImageInstructionString": "To download an image, left click the image and then right click on it",
    "downloadString": "Download",
    "doYouHaveQT": "Do you have...",
    "doYouHaveTemplate": "Do you have <b>{{subject}}</b>?",
    "doYouHaveTemplateES": "Do you have {{subject}}?",
    "doYouMeanString": "Do you mean...",
    "droppedString": "You dropped the task",
    "droppedTaskToString": "Dropped task to {{ params.0 }}",
    "droppedTheTaskString": "dropped the task",
    "droppedTheTaskStringCapitalized": "Dropped the task",
    "dropString": "Drop task",
    "dropTasksString": "Drop tasks",
    "dueDateMustBeAfterStartDateString": "Due date must be after start date",
    "dueDateString": "Due date",
    "duplicateNameString": "Duplicate name",
    "dynamicAddedToString": "Added {{ string1 }} to {{ string2 }}",
    "dynamicAddToString": "Add {{ string1 }} to {{ string2 }}",
    "dynamicFailedAddedToString": "Failed adding {{ string1 }} to {{ string2 }}",
    "earliestStartString": "Earliest start",
    "editCommentString": "Edit comment",
    "editedTaskString": "Edited task",
    "editedTheTaskString": "edited the task",
    "editedTheTaskStringCapitalized": "Edited the task",
    "editGroupNameString": "Edit group name",
    "editGroupString": "Edit group",
    "editQuantityString": "Edit quantity",
    "editRoomSettingsString": "Edit room settings",
    "editString": "Edit",
    "editTaskString": "Edit task",
    "editTeamString": "Edit Team",
    "editUserString": "Edit User",
    "edsDatesString": "EDS dates",
    "edsReachedErrorMessageString": "Could not get the price for this article due to EDS, to create a task for this article, contact your store super user and extend the EDS.",
    "edsString": "EDS",
    "efficiencyFeedbackReasonScoreOptionalString": "What is the primary reason for your score? (optional)",
    "eightWeeksString": "8 Weeks",
    "elevatedStockString": "Elevated",
    "emailString": "Email",
    "employeeIdString": "Employee ID",
    "emptyLocationString": "We can’t find any refilling locations. Please add your own refilling locations here.",
    "emptyString": "Why not pick up an open task?",
    "enableBrowserScannerString": "Enable browser scanner",
    "enableTaskCachingString": "Enable task caching",
    "endDateMustBeAfterStartDateString": "End date must be after start date",
    "endDateMustBeWithinOneYearString": "End date must be within one year of start date",
    "endDateString": "End date",
    "endInputString": "End:",
    "endOfShiftLabelString": "End of shift",
    "enter4DigitPinCodeString": "Enter 4 digit PIN code.",
    "enterLocation2String": "Type the grid code",
    "enterLocationString": "Enter the grid location",
    "enterQuantityString": "Enter quantity",
    "enterRefillQuantityString": "Enter refill quantity",
    "enterUserDetailsString": "Enter the user's name, store, team, and role.",
    "enterUsersNameString": "Enter co-worker's name or email",
    "enterYourPhoneForTodayString": "Enter in the IKEA phone number you’re using today. This number will show up in 'Store Contacts' for others.",
    "entranceAreaString": "Entrance area",
    "errorBoundaryString": "Sorry, something isn't quite right. Please try again later.",
    "errorLoadingStores": "Error loading stores.",
    "errorLoadingStoresString": "Error loading stores.",
    "errorSorryMsg": "Sorry, something isn't quite right.",
    "errorValidNumberString": "Please enter a valid number",
    "estAddonTurnoverString": "Est. add-on turnover",
    "estimatedTurnoverString": "Estimated turnover",
    "eventTypeString_FEEDBACK_REQUEST": "Requests for your feedback",
    "eventTypeString_TASK_ASSIGNED": "Task assigned to me",
    "eventTypeString_TASK_ASSIGNED_TO_TEAM": "Task assigned to my team",
    "eventTypeString_TASK_CLOSED": "Task closed",
    "eventTypeString_TASK_COMMENTED": "Task commented",
    "eventTypeString_TASK_COMPLETED_WITH_CHANGES": "Task completed with changes",
    "eventTypeString_TASK_EDITED": "Task edited",
    "eventTypeString_TASK_IS_FOUR_HOURS_OLD": "Priority task is four hours old",
    "eventTypeString_TASK_IS_ONE_DAY_OLD": "Addon task is one day old",
    "eventTypeString_TASK_PICKED_UP": "Task picked up",
    "eventTypeString_TASK_REASSIGNED": "Task re-assigned",
    "eventTypeString_TASK_REASSIGNED_TO_TEAM": "Task re-assigned to team",
    "eventTypeString_TEAM_TASK_IS_FOUR_HOURS_OLD": "Team's priority task is four hours old",
    "eventTypeString_TEAM_TASK_IS_ONE_DAY_OLD": "Team's addon task is one day old",
    "eventTypeString_TESTBUY_REASSIGNED": "Test buy assigned to me",
    "everyMonthString": "Every month",
    "everyString": "Every",
    "exceedingAvailableStockString": "Exceeding available stock",
    "exceedingMaxPiecesString": "Exceeding max pieces",
    "exceedingMaxThresholdString": "Exceeding max threshold of 3000 pieces",
    "exceedingThresholdString": "Exceeding threshold",
    "excludeEDSArticlesString": "Excluding EDS",
    "excludeOutOfStockString": "Excluding out of stock",
    "exitAreaString": "Exit area",
    "expectedDelivery": "Expected delivery",
    "failedCountString": "Failed {{count}} criteria",
    "failedCreatingTeamString": "Failed creating team {{ teamName }}.",
    "failedDeletingTeamString": "Failed deleting team {{ teamName }}.",
    "failedToCloseAndDeleteTeamTasksString": "Unable to close tasks and delete team. Please try again.",
    "failedToMoveUsersToTeamString": "Unable to move users to the team. Please try again.",
    "failedToReassignTasksAndDeleteTeamString": "Unable to reassign tasks and delete team. Please try again.",
    "failedUpdatingTeamString": "Failed updating team {{ teamName }}.",
    "familyOfferString": "Family offer",
    "FamilyPriceOfferString": "Family price offer",
    "familyQT": "Family",
    "familyString": "Family",
    "februaryString": "February",
    "feedbackIsCompletelyOptionalString": "This feedback is completely optional.",
    "feedbackReasonScoreOptionalString": "What is the reason for your score? (optional)",
    "feedbackString": "How is this app working for you?",
    "feedbackThanksString": "Thank you for your feedback.",
    "feedbackToSenderString": "Feedback to sender",
    "fetchingItemInfoString": "Fetching item info",
    "fewString": "a few seconds ago",
    "fileCouldNotBeLoadedOrDoesNotExistString": "File could not be loaded or doesn’t exist",
    "filesString": "files",
    "filesStringCapitalized": "Files",
    "fileString": "file",
    "fileSuccessfullyUploadedString": "File successfully uploaded.",
    "fileUploadFailedTextString": "An error occurred when trying to upload your file(s).",
    "fileUploadFailedTitleString": "File upload failed",
    "fillInMandatoryFieldsString": "Fill in mandatory fields",
    "fillInMandatoryFieldString": "Fill in mandatory field",
    "filterByTitleString": "Filter by",
    "filterPillAriaString": "filter active",
    "filtersButtonAriaString": "Open filters",
    "filtersString": "Filters",
    "filterString2_one": "Filter ({{count}})",
    "filterString2_other": "Filter ({{count}})",
    "filterString2_zero": "Filter",
    "filterString_one": "Filter({{count}})",
    "filterString_other": "Filter({{count}})",
    "filterString_zero": "Filter",
    "findAllStoreContactsString": "Find all store contacts",
    "findArticleInOtherMediaString": "Find article in other media",
    "firstGroupingString": "First grouping",
    "firstRefill": "Added to location",
    "firstString": "1st",
    "firstStringCapitalized": "First",
    "focusString": "Focus",
    "followUpTaskString": "Follow-up task",
    "foundInAllRoomSettingsString": "Found in the following room settings",
    "foundInFollowingMediasString": "Found in the following media",
    "fourAcesAndKingString": "4 Aces & King",
    "fourVeryMuchString": "4 = very much",
    "fourWeeksString": "4 Weeks",
    "frequencyString": "Frequency",
    "frequentlyString": "Frequently purchased with",
    "fridaysString": "Fridays",
    "fridayString": "Friday",
    "friString": "Fri",
    "fullServeAmountNotIncludedString": "Full-serve amount not included!",
    "furnitureTrolleyString": "Furniture trolley",
    "futureTaskSummaryWithDueText": "The task will appear in the task list on <b>{{start}}</b> and it’s due date is <b>{{due}}</b>",
    "futureTaskSummaryWithoutDueText": "The task will appear in the task list on <b>{{start}}</b>",
    "getNewArticlesString": "Get new articles",
    "getNewArticleSString": "Get new article(s)",
    "getNewArticleSStrings": "Get new article(s)",
    "getNewArticleString": "Get new article",
    "getNewString": "Get new",
    "getPiecesString": "Get {{ count }} piece(s)",
    "getPiecesString_one": "Get {{ count }} piece",
    "getPiecesString_other": "Get {{ count }} pieces",
    "getPiecesString_zero": "No pieces",
    "giveFeedbackString": "Give feedback",
    "globalPassThresholdInformation": "* IKEA global success threshold is set to {{ globalPassThreshold }}%.",
    "globalSuperuserString": "Global Super user",
    "goBackToRefillAreasString": "Go back to refill areas",
    "goBackToRoomListingString": "Go back to room listing",
    "GoodString": "Good",
    "goodString": "Good to know",
    "goOnline2String": "Go online to pick-up",
    "goOnline3String": "Go online to complete",
    "goOnlineString": "Go online to create task",
    "goOnlineToContinueString": "Go back online to continue.",
    "goOnlineToViewString": "Go back online to view tasks.",
    "gotoAdminString": "Go to Admin",
    "goToCashlineAriaString": "Go to cashline survey",
    "goToCashlineString": "Go to Cashline",
    "goToFirebaseString": "Go to Firebase",
    "goToHomePageString": "Go to home page",
    "goToMarkethallAriaString": "Go to markethall survey",
    "goToMarkethallString": "Go to Markethall OW",
    "goToProfilePageString": "Go to profile page",
    "goToScannerString": "Go to scanner",
    "goToSettingsString": "Go to settings",
    "graphOptionsString": "Graph options",
    "greeting": "This is an app for managing and reporting functionalities.",
    "gridCodeAscendingString": "Grid code ascending",
    "gridCodeDescendingString": "Grid code descending",
    "groupByTitleString": "Group by",
    "groupCreatedString": "Group created",
    "groupDeletedString": "Group deleted",
    "groupedArticlesString": "Grouped articles",
    "groupsCountString": "{{ count }} group",
    "groupsCountString_plural": "{{ count }} groups",
    "groupsCountString_other": "{{ count }} groups",
    "groupsString": "Groups",
    "groupString": "Group",
    "groupUpdatedString": "Group updated",
    "guestString": "Guest",
    "hallwayString": "Hallway",
    "handoffRefillString": "Handoff to refill",
    "handoffString": "Almost there",
    "handoffTextString": "To complete this task the items you just picked will need to be refilled in their refill location. Select the person or team that should do that.",
    "hasAssignedString": "{{ creator }} has assigned a task to {{ assignee }}.",
    "hasAssignedTaskToTeamString": "{{ assigner }} has assigned a task to {{ team }}",
    "hasAssignedTaskToYouString": "{{ assigner }} has assigned a task to you",
    "hasAssignedToYouString": "{{ creator }} has assigned a task to you.",
    "hasBecomeFourHoursOldString": "A task assigned to you is 4 hours old.",
    "hasBecomeFourHoursOldTeamString": "A task assigned to your team is 4 hours old.",
    "hasBecomeOneDayOldString": "A task assigned to you is 24 hours old.",
    "hasBecomeOneDayOldTeamString": "A task assigned to your team is 24 hours old.",
    "hasClosedString": "{{ creator }} has closed a task.",
    "hasClosedTaskCreatedByYouString": "{{ changeBy }} has closed a task you created",
    "hasCommentedString": "{{creator}} has commented on a task.",
    "hasCompletedTaskCreatedByYouString": "{{ changeBy }} has completed a task you created",
    "hasCompletedWithChangesString": "{{ creator }} has completed a task with changes.",
    "hasDropTaskCreatedByYouString": "{{ assignedBy }} dropped a task you created to {{ assignedTo }}",
    "hasEditedString": "{{ creator }} has edited a task.",
    "hasFullServerOrderString": "Has full-serve order",
    "hasOngoingTasksWarningString": "There are ongoing tasks. Clicking 'yes' will close all tasks and delete the article.",
    "hasPickedUpString": "{{ creator }} has picked up a task.",
    "hasPickupTaskCreatedByYouString": "{{ assignedBy }} picked up a task you created",
    "hasReassignedString": "{{ creator }} has reassigned a task to {{ assignee }}.",
    "hasReassignedTaskCreatedByYouString": "{{ assignedBy }} has reassigned a task you created",
    "hasReassignedTestbuyToYouString": "{{ creator }} has reassigned a testbuy to you.",
    "hasReassignedToYourTeamString": "{{ creator }} has reassigned a task to your team",
    "hasReassignedToYouString": "{{ creator }} has reassigned a task to you.",
    "hasReleaseTaskCreatedByYouString": "{{ assignedBy }} released a task you created to {{ assignedTo }}",
    "heightString": "Height",
    "hejAppswitcherFooterEditYourLinks": "Edit",
    "hejAppswitcherFooterGotoHej": "Go to Hej!",
    "hejAppswitcherFooterSeeAllLinks": "See all quick links",
    "hejAppswitcherFooterSeeAllLinksV2": "See all",
    "hejAppswitcherListNoneFound": "No quick links found",
    "hejAppswitcherListSectionFrequent": "Frequently used",
    "hejAppswitcherListSectionRelevant": "Relevant links",
    "hejAppswitcherPromotedLinkDescription": "Promoted link based on your profile",
    "hejAppswitcherPromotedLinkTitle": "Promoted",
    "hejAppswitcherRequiresCorporateNetwork": "Requires corporate network",
    "hejAppswitcherSearchPlaceholder": "Search all quick links",
    "hejAppswitcherTitle": "Quick links",
    "hejClearTextButton": "Clear text",
    "hejCloseButton": "Close",
    "hejProfileHeaderProfile": "Profile",
    "hejProfileLabelBack": "Back",
    "hejProfileLabelCompany": "Company",
    "hejProfileLabelContactInformation": "Contact information",
    "hejProfileLabelCopyToClipboard": "Copy to clipboard",
    "hejProfileLabelCostCenterV2": "Cost center",
    "hejProfileLabelDepartment": "Department",
    "hejProfileLabelEmail": "Email",
    "hejProfileLabelEmployeeId": "Employee ID",
    "hejProfileLabelEmploymentInformation": "Employment information",
    "hejProfileLabelLocation": "Location",
    "hejProfileLabelLogout": "Log out",
    "hejProfileLabelMobilePhone": "Mobile phone",
    "hejProfileLabelNetworkId": "Network ID",
    "hejProfileLabelOfficePhone": "Office phone",
    "hejProfileLabelReportsTo": "Reports to",
    "hejProfileLabelSite": "Site",
    "hejProfileLabelYourPersonalInformation": "Your personal information",
    "hejProfileNavigationLanguageDescription": "Phone number, Email, Network ID, Cost center",
    "hejProfileNavigationTravelsDescription": "Book and get support with meetings and travels",
    "hejProfileNavigationTravelsTitle": "Your travels",
    "hejProfileNavigationYourLearningDevelopmentV2": "Your learning & performance",
    "hejProfileNavigationYourPerformanceDevelopmentDescription": "Resources and tools for your learning journey",
    "hejProfileNavigationYourPersonalInformation": "Your personal information",
    "hejProfilePersonSidebarCallUserBusiness": "Call {$INTERPOLATION} {$INTERPOLATION_1}",
    "hejProfilePersonSidebarCallUserMobile": "Call {$INTERPOLATION} {$INTERPOLATION_1}",
    "hejProfilePersonSidebarEmailUser": "Email {$INTERPOLATION}",
    "hejProfileProfileInfoInCdsV2": "Find all your personal information in {$START_LINK}CDS{$CLOSE_LINK}. To access CDS you need to be connected to the corporate network.",
    "hejString": "Hej",
    "helpMakeFixaYouLoveString": "Help us make a Fixa you love <3",
    "helpString": "Help",
    "hfb00String": "Showroom",
    "hfb01String": "Living room seating",
    "hfb02String": "Store and organise furniture",
    "hfb03String": "Workspaces",
    "hfb04String": "Bedroom furniture",
    "hfb05String": "Beds & Mattresses",
    "hfb06String": "Bathroom",
    "hfb07String": "Kitchen",
    "hfb08String": "Dining",
    "hfb09String": "Children's IKEA",
    "hfb10String": "Lighting and Home electronics",
    "hfb11String": "Bed and bath textiles",
    "hfb12String": "Home textiles",
    "hfb13String": "Rugs",
    "hfb14String": "Cooking",
    "hfb15String": "Eating",
    "hfb16String": "Decoration",
    "hfb17String": "Outdoor & Secondary storage",
    "hfb18String": "Home organisation",
    "hfb19String": "Secondary storage",
    "hfb20String": "Other business opportunities",
    "hfb50String": "Home electronics",
    "hfb60String": "Food services",
    "hfb61String": "Consumer Packed Goods",
    "hfb70String": "Home Appliances",
    "hfb92String": "Family",
    "hfb94String": "Administrative Area 94",
    "hfb95String": "Administrative Area 95",
    "hfb96String": "IKEA Food",
    "hfb97String": "Services",
    "hfbAAString": "Activity Area",
    "hfbALLString": "All departments",
    "hfbASString": "ASIS",
    "hfbCLString": "Cashline",
    "hfbFilterOptionString": "HFB {{hfb}}",
    "hfbFilterTitleString": "Item type HFB",
    "hfbLocationInStoreString": "HFB location in store",
    "hfbMOWString": "Market hall Open the wallet",
    "hfbNumberString": "HFB number",
    "hfbOTHERString": "Other areas",
    "hfbOTString": "Other departments",
    "hfbOWString": "Open the Wallet",
    "hfbPickupLocationString": "HFB - Pickup location",
    "hfbQCAString": "Quality cage/area",
    "hfbRCVString": "Recovery",
    "hfbRefillLocationString": "HFB - Refill location",
    "hfbSelectionString": "Select maximum {{ max }} HFBs",
    "hfbSFMString": "Swedish Food Market",
    "hfbSLSString": "Markethall",
    "hfbSOWString": "Showroom Open the wallet",
    "hfbSSFAString": "Self serve furniture area",
    "hfbString": "HFB",
    "hfbSTString": "Staircase",
    "hfbWHString": "Warehouse",
    "hideCompleted": "Hide {{ count }} completed",
    "highestEstTurnover": "Highest est. turnover",
    "historyString": "History",
    "homeAndPrimaryString": "Home/Primary",
    "homebaseHfbString": "Homebase HFB",
    "homeBaseString": "Home base",
    "homebaseString": "Homebase",
    "homeBoxContentString": "All add-ons sold in {{hfb}}",
    "homeBoxTitleString": "in Home",
    "homeDepartmentString": "Home",
    "homeExplanationString": "A department is Home to add-on articles when having them in their sales bins.",
    "homeLocationString": "Home location",
    "homeNoRoomsAddedString": "No rooms added to this Home.",
    "homePageNewsCardDescriptionScannerString": "You can now scan QR codes on the products in Fixa. Try the new scanner by activating it with the button to the right",
    "homePageNewsCardDescriptionString": "After not working to the standard that we expected for a while, we are happy to announce that the Add-on insights are now live again. You can find it under the Add-on section in the menu.",
    "homePageNewsCardTitleScannerString": "QR/Datamatrix scanning is now available",
    "homePageNewsCardTitleString": "New Add-on insights live",
    "homeString": "Home",
    "hoursAgoString": "hours ago",
    "hoursString": "hours",
    "hourString": "hour",
    "howBigIsTheQuantityAffectedString": "How big is the quantity affected?",
    "howDidYouDiscoverString": "How did you discover the problem?",
    "howIsThisCalculatedString": "How is this calculated?",
    "howManyPiecesMultiPackString": "How many pieces in a multipack?",
    "howManyPiecesPalletString": "How many pieces on a pallet?",
    "howManyPTagsString": "How many P-tags?",
    "howToSetUpUpptackaHomescreenString": "How to set up Upptäcka homescreen",
    "howToShopQT": "How to shop",
    "howToString": "How to",
    "iDontHaveASuppliedNumber": "I don't have the supplier number",
    "ifYouLeaveNow": "If you leave now, your edits will be lost.",
    "ikeaBagString": "IKEA bag",
    "ikeaPhoneNumber": "IKEA phone number",
    "ikeaPriceString": "IKEA Family price",
    "ikeaStorePhoneString": "IKEA store phone",
    "imageCarouselString": "Image carousel",
    "imageCouldNotBeLoadedString": "Image could not be loaded or doesn’t exist",
    "imageFailedUploadString": "Could not upload {{ imageName }}.",
    "imageFolderString": "Image folder",
    "imageLowerCaseString": "image",
    "imagesLowerCaseString": "images",
    "imagesString": "Images",
    "imageString": "Image",
    "imageUploadErrorString": "One or more images are too large to upload. Please select images that are smaller than {{ maxFileSize }}.",
    "imageUploadFailedTextString": "An error occurred when trying to upload your image(s).",
    "imageUploadFailedTitleString": "Image upload failed",
    "impactedImagesDescriptionString": "Take new images to represent the media in the current state.",
    "impactedImagesHeadlineString": "There are {{count}} images containing articles recently deleted from the article list",
    "inactiveString": "Inactive",
    "includeEDSArticlesString": "Include EDS articles",
    "includeOutgoingArticlesString": "Include outgoing articles",
    "includeOutOfStockString": "Include out of stock articles",
    "increaseQuantityString": "Increase",
    "increaseValueString": "Increase value",
    "indeliveryString": "Indelivery",
    "infoAddPhoto": "Be mindful of others' privacy. When taking or uploading photos, please avoid capturing other people or sensitive data.",
    "inFollowingMediaString": "In following media",
    "infoString": "Setting a task to repeat is great for tasks that occur on a regular basis. You can manage recurring tasks in the Planned section in Activity.",
    "inGroupFirstUppercaseString": "In group",
    "inGroupsString": "In groups",
    "inGroupString": "in group",
    "inMediaString": "In media",
    "inProgressInMyStoreString": "In progress in my store",
    "inProgressInMyTeamString": "In progress in my team",
    "inProgressString": "In progress",
    "inProgressTasksString": "In progress tasks",
    "insertArticlesAndDesignString": "Insert articles & design codes",
    "insertArticlesString": "Insert articles",
    "insightPiecesLongString": "Number of pieces",
    "insightPircesRefilledString": "Pieces refilled",
    "insights2Performance1String": "See the <b>estimated turnover</b> of add-on sales based on pieces refilled with Fixa. You can also see the best performing article in the store.",
    "insights2Performance2String": "See a more <b>detailed view</b> of the sales as well as the <b>highest</b> and <b>lowest turnover</b> of refill articles and locations in your <b>store</b>.",
    "insights2Performance3String": "See how a <b>specific HFB</b> is performing based on the <b>refills done</b>. <b>Filter</b> this on different time frames by tapping the <b>black box</b> or tap on this section to see a more detailed view.",
    "insights2Performance4String": "If you filter on <b>Home</b> you can see all add-ons sold in the selected HFB. You can view <b>performance</b> for both <b>articles</b> and <b>locations</b>.",
    "insights2Performance5String": "If you <b>filter</b> on <b>Away</b> you can see all add-ons from the selected HFB, sold outside of the selected HFB. You can view <b>performance</b> for both <b>articles</b> and <b>locations</b>.",
    "insights2Performance6String": "<b>Use filters</b> to choose what information you would like to see.",
    "insightsAddonArticleListTitle": "Add-on articles",
    "insightsAddonLocationListTitle": "Add-on sales locations",
    "insightsAddonSalesLocationListTitle": "Add-on sales locations",
    "insightsContentString": "Track refill statistics for a particular HFB or the whole store.",
    "insightsDeprecationBannerBodyPartOne": "Add-On Insights is inaccurate and, due to limited resources, no longer supported. Please use the Fixa dashboard (",
    "insightsDeprecationBannerBodyPartTwo": ") for accurate and comprehensive data. Stay tuned, a new Fixa add-on insight is on it's way!",
    "insightsDeprecationBannerTitle": "Please use Fixa dashboard",
    "insightsGraphError": "Unable to load graph",
    "insightShareString": "Add-on article sale shares",
    "insightsIngress2String": "View add-on insights for your store here. This information can improve sales in your store by helping you make data-driven product and location decisions.",
    "insightsStoreViewString": "Insights store view",
    "insightsString": "Insights",
    "insightsSubtitleAt": "{{product}} at {{location_id}}",
    "insightsTableRowRangeString": "Showing {{ firstRowNumber }} - {{ lastRowNumber }} out of {{ totalRowCount }}",
    "insightsTotalRefilledString": "Total refilled",
    "insightsTutorialContentString": "Use them within your team or store",
    "insightsTutorialString": "Insights & AOS performance",
    "insightTurnoverString": "Est. turnover",
    "insightValueString": "Value to show",
    "inStockString": "in stock",
    "inStockTitle": "In stock",
    "inString": "In",
    "insufficientArticles": "Not enough articles could be obtained for creating TestBuy.",
    "insufficientArticlesInHFBString": "There are not enough 4A1K articles in {{hfb}} to start a Test buy.",
    "insufficientHfbsDescriptionPart1String": "There aren't enough articles to be tested for some of the HFB(s) you have selected.",
    "insufficientHfbsDescriptionPart2String": "The available amount of articles have already been part of a completed Test buy today or there are no articles available for {{hfbLabels}}.",
    "insufficientHfbsDescriptionPart3String": "Please try again later or tomorrow.",
    "introducingString": "We’re introducing a new way to look at add-on sales.",
    "invalidDateFormatString": "Invalid date format. Please use YYMM or YYMMDD.",
    "invalidDateString": "Invalid date format. Please use YYMM or YYMMDD.",
    "invalidLinkErrorString": "Please enter a valid link starting with http:// or https://",
    "inXLocationsString": "in {{ count }} locations",
    "inXLocationsString_other": "in {{ count }} locations",
    "inXMediaString": "in {{ count }} media",
    "inXRoomSettingsString": "in {{ count }} room settings",
    "isCreateUserError": "Something happened while creating your account, please try again later.",
    "isProductMainOrBackupWarningString": "This is a Main / Backup Product. If you create and complete the task then the Main / Backup product association will be removed.",
    "issueNameAssemblyString": "Poorly assembled",
    "issueNameDamagedString": "Damaged or broken",
    "issueNameDirtyString": "Dirty",
    "issueNameInventoryString": "Inventory Error",
    "issueNameMissingDisplayModelString": "Missing display model",
    "issueNameMissingPartsString": "Missing parts",
    "issueNameNoPriceTagString": "No P-tag",
    "issueNameOtherString": "Other",
    "issueNameOutOfStockString": "Not in stock",
    "issueNameRackingString": "Racking",
    "issueNameWrongSalesLocationString": "Wrong sales location",
    "issueString": "Issue",
    "issueTitleAssemblyString": "Fix Product",
    "issueTitleDamagedString": "Fix Product",
    "issueTitleDirtyString": "Clean product",
    "issueTitleInventoryString": "Check Inventory",
    "issueTitleMissingPartsString": "Fix product",
    "issueTitleNoPriceTagString": "Add P-tag",
    "issueTitleOtherString": "Product issue",
    "issueTitleOutOfStockString": "Product out of stock",
    "issueTitleRackingString": "Change racking",
    "isThisPQTeam": "Is this a Product Quality team?",
    "itemHfbNoString": "Item Type HFB",
    "itemHfbTypeInsightsString": "Item Type HFB",
    "itemNoString": "Item Number",
    "itemRefillLocationGridCodeString": "SLID",
    "itemsFromString": "from",
    "itemsRefilledString": "{{formattedAmount}} ITEMS REFILLED",
    "itemsToString": "to",
    "iUnderstandString": "I understand",
    "januaryString": "January",
    "joinTeamString": "Join a team",
    "julyString": "July",
    "juneString": "June",
    "justNowString": "Just now",
    "justRefillsPiecesString": "Refills (pieces)",
    "keepString": "Keep the task with me",
    "keepTasksAssignedToMeString": "Keep tasks assigned to me",
    "kingString": "King",
    "KingString": "King",
    "kitchenString": "Kitchen",
    "landingPageHFBdepsString": "Landing page HFB departments",
    "languageString": "Language",
    "laserScanString": "Laser scan",
    "last4WeeksString": "Last 4 weeks",
    "last6MonthsString": "Last 6 months",
    "last7DaysString": "Last 7 days",
    "lastActiveAtString": "Last Active At",
    "lastAskedAtString": "Last: {{date}}",
    "lastCreatedString": "Last created",
    "lastInSeriesString": "Last in series",
    "lastOccurrenceString": "Last occurrence",
    "lastRecordedDayString": "Last recorded day",
    "lastRefill": "Last refill",
    "lastRefilledAt": "Last refilled: {{count}} pcs",
    "lastString": "last",
    "lastStringCapitalized": "Last",
    "lastSTwasString": "Last shopping tools session was",
    "lastTeamInThisStoreString": "This is last team in this store",
    "lastTertialString": "Last tertial",
    "latestStartString": "Latest start",
    "launchLabelString": "Launch",
    "launchMediaExtractedMediaCountString": "{{count}} media extracted",
    "launchMediaExtractedMediaCountString_plural": "{{count}} media extracted",
    "launchMediaExtractedMediaCountString_other": "{{count}} media extracted",
    "launchMediaExtractedStatusString": "Extracted",
    "launchMediaExtractingMediaFromFileString": "Extracting media from {{fileName}}",
    "launchMediaExtractingMediaFromString": "Extracting media from",
    "launchMediaExtractingMediaString": "Extracting media",
    "launchMediaExtractingNextMediaString": "Extracting next media...",
    "launchMediaUploadBrowseString": "browse",
    "launchMediaUploadDropFilesHereString": "Drop your file(s) here",
    "launchMediaUploadDropFilesString": "Drop your file(s) here or",
    "launchMediaUploadFileInputLabelString": "Select launch media file",
    "launchMediaUploadFileTooLargeString": "File size cannot exceed {{ maxFileSizeMb }} MB.",
    "launchMediaUploadHelperString": "Max. file size: {{ maxFileSizeMb }} MB · {{ acceptedFileExtensions }} formats accepted",
    "launchMediaUploadUnsupportedFileTypeString": "Only {{ acceptedFileExtensions }} files are allowed.",
    "learnedAboutString": "You've just learned about",
    "learnedHowString": "You just learned how to",
    "learnMoreString": "Learn more",
    "leastPieces": "Least pieces",
    "leastRecentlyRefilledString": "Least recently refilled",
    "leastRecentlyString": "Least recently",
    "leastUsersString": "Least amount of users",
    "leaveNoteString": "Want to leave a note?",
    "leaveWithoutSaving": "Leave without saving",
    "leavingFixaDescriptionString": "This link will take you to an external website. Are you sure you want to continue?",
    "leavingFixaString": "You're about to leave Fixa",
    "lengthString": "Length",
    "lessThanDayString": "less than a day ago",
    "levelCompletedString": "Level completed",
    "levelString": "Level",
    "lifeHomeActivityString": "Life at home activity",
    "lifeHomePriorityString": "Life at home priority",
    "linkAlreadyAddedErrorString": "This link has already been added",
    "linksString": "links",
    "linksStringCapitalized": "Links",
    "linkString": "link",
    "linkToFixaAdminString": "Link to Fixa Admin:",
    "linkUrlString": "Link URL",
    "listOfSuperUsersString": "List of super users",
    "littleStockString": "There are only {{ count }} pieces in stock. Your request might not be fully completed.",
    "livingConditionsString": "Living conditions",
    "livingRoomString": "Living room",
    "livingSituationCannotBeEmptyString": "Living situation cannot be empty",
    "livingSituationString": "Living situation",
    "livligLinkDescription": "Find live sales performance in Livlig for this product",
    "livligLinkGoto": "Go to Livlig",
    "livligLinkTitle": "Live sales performance in Livlig",
    "livligLinkWidgetTitle": "Livlig live sales performance",
    "livligSalesPerformanceOfArticlesString": "Sales performance of articles",
    "livligViewInString": "View in Livlig",
    "loadingEllipsisString": "Loading...",
    "loadingString": "Loading ...",
    "loadMore": "Load more",
    "loadMoreCountsString": "Showing {{ loadedItemsCount }} of {{ totalCount}} results",
    "localCombinationArticlesExcluded": "Please note that sales combination / \"SCI\" articles are currently excluded from the search.",
    "localCombinationCountString": "Combination of {{ count }} articles",
    "localCombinationCountString_one": "Combination of {{ count }} article",
    "localCombinationCountString_other": "Combination of {{ count }} articles",
    "localCombinationCountString_zero": "No articles in combination",
    "localCombinationDeletedString": "Deleted local combination",
    "localCombinationGreyStripArticleString_one": "{{ count }} article",
    "localCombinationGreyStripArticleString_other": "{{ count }} articles",
    "localCombinationGreyStripArticleString_zero": "Article",
    "localCombinationGreyStripCountString_one": "{{ count }} piece",
    "localCombinationGreyStripCountString_other": "{{ count }} pieces",
    "localCombinationGreyStripCountString_zero": "Piece",
    "localCombinationGreyStripString": "{{articles}} articles, {{pieces}} pieces",
    "localCombinationInformationDescriptionString": "Product information for local combinations have been deleted.",
    "localCombinationInformationHeadingString_one": "Changes to {{ count }} article in media",
    "localCombinationInformationHeadingString_other": "Changes to {{ count }} articles in media",
    "localCombinationInformationMessageOneString": "We do not have any article information because the local combination has been deleted in P-tag.",
    "localCombinationInformationMessageTwoString": "Please create a new combination in P-tag and replace it, and/or delete this local combination from this media.",
    "localCombinationNewsString": "NEWS! You can now add local combination articles in Media Maintenance - Try it out!",
    "localCombinationSubArticlePanelString": "This article is part of a combination",
    "locale": "en-GB",
    "localSafetyRequirementsString": "Local safety requirements",
    "location2String": "Refilling location",
    "location3String": "Location",
    "locationAndSizeOfString": "Location & Size of {{name}}",
    "locationCannotBeEmptyString": "Location cannot be empty",
    "locationFilterLabelString": "Location",
    "locationFilterString": "Filter by location",
    "locationNameTooLong": "Location names are limited to maximum 6 characters",
    "locationNameTooShort": "Location names need to be minimum 6 characters",
    "locationOfString": "Location of {{name}}",
    "locationsCreatedInFixaString": "Locations created in Fixa",
    "locationsCreatedInFixaWillBeDeletedString": "Locations created in Fixa will be automatically deleted after 28 days if it’s not used in any task.",
    "locationsNotAvailableString": "Locations is not available for this task type",
    "locationsString": "Locations",
    "locationString": "Add location",
    "locationTotalPieces": "Location total",
    "location_grid_codeString": "Grid code",
    "login": "Sign in with Network ID",
    "loginFailureDescriptionString": "There is an issue with login right now. Please try again later.",
    "loginFailureString": "Sorry, login failed",
    "logoutString": "Log out",
    "longtermPriorityString": "Long-term priority",
    "lookAtTutorialsString": "Take a look at available tutorials",
    "lostSalesDescriptionString": "Total sum of articles that failed in this test buy",
    "lostSalesString": "Lost sales",
    "lowestEstTurnover": "Lowest est. turnover",
    "lowInStockTitle": "Low in stock",
    "lowPricString": "New low price",
    "mainImageString": "Main image",
    "mainMessageMainActivityString": "Main message/Main activity",
    "mainMessageString": "Main message",
    "mainProductBasicString": "Main product",
    "mainProductOneString": "MAIN PRODUCT 1",
    "MainProductsString": "Main products",
    "mainProductString": "MAIN PRODUCT",
    "mainProductTwoString": "MAIN PRODUCT 2",
    "mainScheduledTasksString": "Main scheduled tasks",
    "mainScheduledTaskString": "Main scheduled task",
    "maintenanceDescriptionString": "We are currently updating the Fixa app. We will be back shortly.",
    "maintenanceString": "Maintenance",
    "manageString": "Manage phone numbers",
    "mandatoryString": "Mandatory",
    "manualsString": "Manuals",
    "marchString": "March",
    "markAllReadWithCountString": "Mark all read ({{ count }})",
    "markAsCompletedForAllString": "Mark all as completed",
    "markAsCompleteString": "Mark as complete",
    "markAsPriorityForAllString": "Mark all as priority",
    "markAsRemovedString": "Mark as removed",
    "markethallEntranceString": "Markethall Entrance",
    "markethallOpenTheWalletString": "Markethall - Open the wallet",
    "markethallOTWString": "Markethall OTW",
    "markethallOWString": "Markethall OW",
    "MarkethallString": "Markethall",
    "markethallString": "Markethall",
    "markingAsCompleteDetailString": "Turn this on if you have already picked and refilled these items.",
    "markingAsCompleteString": "Marking as complete",
    "materials2String": "Materials",
    "materialsAndCareString": "Materials and care",
    "materialsString": "Materials and care",
    "maxAmountInLocationString": "The max for this location is {{ count }} pieces.",
    "maxCapacityString": "Max Capacity (pcs)",
    "maxHfbSelectionInfoString": "You can select a maximum of {{max}} HFBs",
    "maxHfbSelectionString": "More than {{ max }} HFBs selected",
    "maximumCapacityString": "Maximum capacity",
    "maximumCharactersLengthString": "Maximum length is {{count}} characters",
    "maximumQuantityMessageString": "The maximum quantity for add-on orders is 3000 pieces. Please make multiple add-on orders if you need to refill a larger amount.",
    "maxInLocation": "Max in location",
    "maxNDigits": "{{ length }} digits required",
    "maxNUnitsString": "Max {{ quantity }} {{ unit }}",
    "maxOnLocationString": "{{maxAmount}} max for location",
    "maxPiecesOnLocationString": "{{maxAmount}} pieces max for location",
    "maxSelectionString": "More than {{ max }} items selected",
    "maxStockAndAmountString": "The max for this location is {{ max }} pieces and there are {{ stock }} in stock.",
    "maxToolAmountReachedString": "Maximum amount reached",
    "mayString": "May",
    "mediaCountString": "{{ count }} media",
    "mediaCountString_other": "{{ count }} media",
    "mediaDeletedInTaskDescriptionString": "All the media in this task have been removed",
    "mediaDeletedString": "Media deleted",
    "mediaMaintenanceBannerBodyString": "Select several articles in a media and add them all to one task. Or create one task for an article across every media it's in. Fewer tasks, everything in one place.",
    "mediaMaintenanceBannerTitleString": "Create smarter Media maintenance tasks",
    "mediaMaintenancePIPLink": "Media Maintenance",
    "mediaMaintenanceRoomSettingsString": "Media maintenance (Room settings)",
    "mediaMaintenanceString": "Media maintenance",
    "mediaManagementString": "Media Management",
    "mediaNameString": "Media name",
    "mediaNoArticlesAddedString": "No articles added to this media.",
    "mediaNotFoundString": "Media not found",
    "mediaPlacementsString": "Media placements",
    "mediasString": "media",
    "mediaStoryString": "Main story for the media",
    "mediaString": "media",
    "mediasViewSearch": "Search for article or media",
    "mediaTypeChangeDialogFieldsString": "Some settings for the media might be reset and you have to fill it out again.",
    "mediaTypeChangeDialogHeaderString": "Are you sure you want to change '{{mediaName}}' from '{{oldMediaType}}' to '{{newMediaType}}'?",
    "mediaTypeChangeDialogReassureString": "But, don't worry about articles, groups and photos - they will remain as they are!",
    "mediaTypeString": "Media type",
    "mediaWithNoOngoingTasksString": "Media with no ongoing tasks",
    "mediaWithOngoingTasksString": "Media with ongoing tasks",
    "membersString": "No members available",
    "menuString": "Menu",
    "merchandisingPaString": "Merchandising PA",
    "mergeNotPossibleMessageString": "You cannot merge with a question that have an ongoing tasks.",
    "mergeSuccessString": "Merge completed!",
    "meString": "Me",
    "metersUnit": "meters",
    "meterUnit": "meter",
    "mfaq01String": "Open the customer MFAQs by selecting <b>Customer MFAQ</b> from the list on the Home page.",
    "mfaq02String": "Questions are sorted by <b>highest vote count</b>. To add a vote, tap on the <b>plus icon</b> to increase the vote by one.",
    "mfaq03String": "Tap on the <b>filters</b> at the top to refine the list of questions.",
    "mfaq04String": "Set the <b>time period</b> and <b>area</b> you want to refine your list to. Note your selection will be saved for the next time you view the MFAQs.",
    "mfaq05String": "Tap on a question to see the <b>details for the question</b>.",
    "mfaq06String": "In the question details, you can <b>increase</b> and <b>decrease</b> the vote count and view a <b>summary</b> of the total vote count over time for the selected area.",
    "mfaq07String": "To <b>search</b> for a question, tap on the magnifying glass icon in the top-right corner.",
    "mfaq08String": "If there are no search results you can create a new question by tapping <b>Create new question</b> at the bottom.",
    "mfaq09String": "You can also add a new question by tapping the <b>Add new question</b> button at the bottom.",
    "mfaq10String": "When adding a new question, select the <b>area</b> where the question was asked and select the question <b>category</b>.",
    "mfaq11String": "Type your question. Check the <b>preview</b> for typos and that your question <b>doesn't already exist</b> for your area.",
    "mfaqAddQuestionInfoBoxString": "In order to filter and later analyse the questions it’s important to select the correct area.",
    "mfaqAddQuestionInstructions1String": "In order to filter and later analyse the questions it’s important to select the correct location and type of question.",
    "mfaqAddQuestionInstructionsString": "In order to filter and later analyse the questions it’s important to select the correct area and type of question.",
    "mfaqCountWasString": "count was",
    "mfaqEditQuestionString": "Edit question",
    "mfaqFollowUpTaskExplanation1String": "The task will only be related to the area you created the task for.",
    "mfaqFollowUpTaskExplanation2String": "Once the task is completed, the count for upvotes will automatically be set to 0, so that you can compare the number of upvotes before and after the resolution was implemented.",
    "mfaqFollowUpTaskNameString": "Most Frequently Asked Questions Follow-up Task",
    "mfaqFollowUpTaskString": "MFAQ Follow-up",
    "mfaqFollowUpTitle": "MFAQ Follow-up",
    "mfaqGraphTaskCompletedLabel": "Task completed!",
    "mfaqGraphTaskCreatedLabel": "Task created!",
    "mfaqGraphTimeLabel": "Time",
    "mfaqGraphUpvotesLabel": "Upvotes",
    "mfaqGuideIntroString": "Collect, count and sort important questions asked by customers.",
    "mfaqGuideString": "Most Frequently Asked Questions (MFAQ)",
    "mfaqInLocationString": "in {{location}}",
    "mfaqMergeAnnouncement1": "Start the merge and simply search for the other question you want to merge with.",
    "mfaqMergeAnnouncement2": "Currently, you can not merge if both questions have ongoing tasks in any area.",
    "mfaqMergeAnnouncement3": "After the merge, the upvotes of the 2 questions will be combined. You can still see the vote distribution for specific areas as before.",
    "mfaqMergeAnnouncementSubHeading1": "Merging with ongoing tasks",
    "mfaqMergeAnnouncementSubHeading2": "Combined upvotes",
    "mfaqMergeAnnouncementSummary": "Found questions that are similar or have the same meaning? Merge them together to keep a better overview of the total upvotes.",
    "mfaqMergeAnnouncementTitle": "Merge together similar questions",
    "mfaqMergeCompletedString": "Merge completed!",
    "mfaqMergeQuestionString": "Merge question",
    "mfaqMergeString": "Merge",
    "mfaqMergeUpvotesCountString": "+ {{count}} upvote",
    "mfaqMergeUpvotesCountString_plural": "+ {{count}} upvotes",
    "mfaqMergeUpvotesCountString_other": "+ {{count}} upvotes",
    "mfaqMergeWithString": "Merge with",
    "mfaqNoTaskString": "No task",
    "mfaqQuestionString": "Customer MFAQ",
    "mfaqRenamedFromString": "Renamed from",
    "mfaqResolution": "Resolution",
    "mfaqResolutionSubTitle": "Describe what you did.",
    "mfaqResolutionValidationString": "Please fill in the resolution for the task",
    "mfaqResolutionWidgetSubTitle": "Describe what you did to resolve this task.",
    "mfaqSelectAreaInstructionsString": "Questions are filtered by area. Remember to select the filter that corresponds to where you’re gathering questions from, e.g. ‘HFB01’.",
    "mfaqSelectCorrectAreaString": "Select the correct area",
    "mfaqSelectCorrectLocationString": "Select the correct location",
    "mfaqSelectLocationInstructionsString": "Questions are filtered by location, remember to select the filter that corresponds to where you’re gathering questions from, ex ‘HFB01’.",
    "mfaqSelectRightDetailsString": "Select the right details",
    "mfaqTaskCreatedString": "Task created: {{taskCreatedDate}}",
    "mfaqTaskInfoButtonAriaLabelString": "More information about the task",
    "mfaqTaskResolvedString": "Task resolved",
    "middayRoundString": "Midday round",
    "middayString": "Midday",
    "minimumOnePieceString": "Minimum 1 piece",
    "minutesString": "minutes",
    "minuteString": "minute",
    "missingSettingsString": "Missing Settings",
    "missingStoreBodyString": "If you are missing a store you need access to, you need to request access for it through My Identity.",
    "missingStoreString": "Missing a store?",
    "missingTeamBodyString": "Contact your store or country super user for team setup. You can change teams later in the app.",
    "missingTeamString": "Missing a team?",
    "mistakenQuantityString": "Mistaken Quantity",
    "mistakenQuantityString (Copy)": "Mistaken Quantity",
    "mondaysString": "Mondays",
    "mondayString": "Monday",
    "monString": "Mon",
    "monthlyDayOfTheMonthString": "Monthly, day {{day}} of the month",
    "monthlyOrdinalOfTheMonthString": "Monthly, {{ordinal}} {{weekday}} of the month",
    "monthlyRecurrenceTextDate": "Task will be scheduled to repeat once every {{interval}} {{month}} on <b>the {{date}}</b>.",
    "monthlyRecurrenceTextWeekday": "Task will be scheduled to repeat once every {{interval}} {{month}} on <b>the {{ordinal}} {{weekday}}</b>.",
    "monthlyRepeatingTaskSummaryText": "The task is scheduled to repeat once every {{interval}} {{month}} on {{recurrence}} of the month starting <b>{{start}}</b> until <b>{{end}}</b>",
    "monthlyRepeatingTaskSummaryText2": "The task is scheduled to repeat once every month on {{recurrence}} of the month starting <b>{{start}}</b> until <b>{{end}}</b>",
    "monthlyRepeatString": "Every month on the",
    "monthlyString": "Monthly",
    "monthsAgoString": "months ago",
    "monthsString": "months",
    "monthString": "month",
    "monthStringCapitalized": "Month",
    "moreButton": "More",
    "moreThingsString": "More {{ things }}",
    "moreToRefillQuestionString": "More items to refill?",
    "morningRoundString": "Morning round",
    "morningString": "Morning",
    "mostPieces": "Most pieces",
    "mostRecentlyRefilledString": "Most recently refilled",
    "mostRecentlyString": "Most recently",
    "mostUsersString": "Most amount of users",
    "moveAllArticlesInfoString": "Groups: all articles are moved",
    "movedNUsersToTeamString": "{{count}} user moved to the team",
    "movedNUsersToTeamString_plural": "{{count}} users moved to the team",
    "movedNUsersToTeamString_other": "{{count}} users moved to the team",
    "moveExpandedArticlesInfoString": "Groups: all articles are moved but with new count: {{ newCount }}",
    "moveReducedArticlesInfoString": "Groups: moving {{ moveCount }} articles to group. Remaining {{ remainingCount }} articles will not be moved.",
    "moveUsersToDifferentTeamDescriptionString": "Users need to be moved to another team. This can be changed later at anytime.",
    "moveUsersToDifferentTeamString": "Move users to different team",
    "moveUsersToOtherTeam": "Move users to other Team",
    "moveUsersToOtherTeamString": "Move users to other Team",
    "multiHfbAnnouncementBodyString": "You can now select up to three HFBs when setting up a random test buy, giving you broader coverage in one test buy.",
    "multiHfbAnnouncementTitleString": "Multi-HFB selection for random test buy now live!",
    "multiOrderAddOnsString": "Multi-order of add-ons",
    "multiOrderRelatedRefillsSumString": "{{ count }} pieces ordered in total",
    "multipackSettingsTitleString": "Multi-pack settings",
    "multipackSettingsUnit": "pieces/multi-pack",
    "multipacksString": "Multipacks",
    "multipackString": "Multi-pack",
    "multiPacksUnit": "multipacks",
    "multipackTitleString": "Multi-pack ({{ count }})",
    "multiPackUnit": "multipack",
    "multipleHfbSelectionInfoString": "Selected {{count}} of {{max}} HFBs",
    "multipleToolsString": "Multiple tools",
    "multiselectAnnouncement1": "In My Tasks or Open Tasks, tap on the icon <icon /> in the top right corner, or tap and hold one task to show the multi-select view.",
    "multiselectAnnouncement2": "Then, select all the tasks you want to apply the same action to. Tap the black button at the bottom and choose the action you want to apply.",
    "multiselectAnnouncementHeading": "Select multiple tasks at once in My Tasks and Open Tasks to pick-up,reassign and drop tasks.",
    "multiselectAnnouncementSubHeading": "How to use multi-select",
    "multiselectAnnouncementTitle": "Work in bulk with multi-select!",
    "multiSelectPopupInfo1": "When applying an action to multiple tasks, it can happen that some tasks were already changed meanwhile and therefore cannot be changed by your action.",
    "multiSelectPopupInfo2": "For example, if you try to pick up 8 tasks and 4 of them have been picked up by another coworker in the meantime, we'll automatically apply the pick-up task only to the tasks that are still open for pickup.",
    "multiSelectProcessing": "Processing...",
    "multiSelectTasksString": "Multi-select tasks",
    "multiSeletingPopupTitle": "Multi-selecting",
    "myCurrentTeamString": "My current team",
    "myIdentityString": "My Identity",
    "myString": "My tasks",
    "myTasks1String": "<b>Swipe the task all the way</b> to the right to complete. <b>Swipe right half way</b> to see options for Complete or Complete with changes.",
    "myTasks2String": "<b>Alternatively</b>, tap on the task card to get a detailed view and <b>Complete</b> or <b>Complete with changes</b>.",
    "myTasks3String": "Turn on <b>Complete picking</b> only if you will pick the articles, and another co-worker will be placing them in their final refill location.",
    "myTasks4String": "You can <b>make notes</b> or <b>upload photos</b> at the bottom of the task detail.",
    "myTasksContentString": "Tasks assigned to you or the ones you have picked up. ",
    "myTeamString": "My Team",
    "nameAlreadyExistsString": "'{{name}}' already exists",
    "nameCannotBeEmptyString": "Name cannot be empty",
    "nameOfGroupString": "Name of group",
    "nameOfString": "Name of {{name}}",
    "nameString": "Name",
    "nameWasUpdatedString": "{{ name }} was updated!",
    "namingGuideLinesString": "Naming guidelines",
    "navDescriptionString": "You need to be online to pick-up, complete and edit tasks.",
    "navigateAndCreateTasksString": "Navigate and create tasks in Fixa",
    "nearbyAddonsDescriptionString": "Showing only refills up to 3 weeks. If you create more add-ons at a nearby grid code, they will show up here.",
    "nearbyAddonsString": "Nearby add-ons",
    "needString": "Need some help?",
    "needToAssignToCreateString": "You need to assign the task to create it",
    "needToChooseTeamString": "You need to choose a new team",
    "negativeString": "Keep editing",
    "neverString": "Never",
    "new2String": "New",
    "newArticleString": "New article",
    "NewArticleString": "News",
    "newCommentsString": "New comments",
    "newCustomTestBuy": "New custom test buy",
    "newestFirstString": "Newest first",
    "NewLowerPriceString": "New lower price",
    "newOptionHomeScreenString": "New option available for the home screen",
    "newProductString": "New product",
    "newsString": "NEWS",
    "newString": "New task",
    "newTestBuy": "New test buy",
    "newVersionAvailableString": "New version available",
    "next": "Next",
    "nextImageString": "Next image",
    "nextPageString": "Next page",
    "nextTopicString": "Next topic:",
    "nlpString": "NLP",
    "noAccessDescriptionString": "Access to Fixa is automatically approved for co-workers in store units that are active in Fixa. If you need any support - please create a ticket for Fixa in NowIT.",
    "noAccessMessageString": "Sorry, you don’t have access to Fixa",
    "noAcesAndKingDataBodyString": "To make 4 Aces & King work here, a person from the Service Office needs to have this data entered (for example: Sales Support Specialist or Sales Performance)",
    "noAcesAndKingDataTitleString": "Your country has no data yet.",
    "noAddonsInThisAreaDescriptionString": "Sorry, we could not find any add-ons in this area. Please make sure sales locations IDs are named correctly in SLM according to the global naming convention.",
    "noAddonsInThisAreaString": "No Add-ons in this area",
    "noAreaSelectedString": "You can't create a test buy without selecting a location, please select a location and try again.",
    "noArticlesAvailableDescriptionString": "We could not fetch any articles to start Test buy.",
    "noArticlesAvailableForHfbString": "For {{ hfb }} there were no articles available for the selected Test buy.",
    "noArticlesAvailableString": "No articles available",
    "noArticlesAvailableToReplaceString": "No articles available to replace with. Try again later or tomorrow.",
    "noArticlesInGroupString": "No articles in this group yet",
    "noArticlesString": "No articles",
    "noArticlesToViewString": "No articles to view",
    "noChangeString": "No change",
    "noCommentsString": "No new comments to see here.",
    "noDataMessage": "No data found",
    "noDataString": "No data",
    "noDepartmantsAvailableForFilter": "No departments available for selected filters.",
    "noDescriptionString": "No description",
    "noDestinationTeamsAvailableString": "No teams available.",
    "noFilesSelectedString": "No files selected",
    "noGroupingString": "No grouping",
    "noGroupsCreatedYetClarificationString": "Group articles together in an area for easier way finding, or to help you keep the media in shape as new",
    "noGroupsCreatedYetString": "No groups created yet",
    "noImagesAddedYetString": "No images added yet",
    "noImagesSelectedString": "No images selected",
    "noImageString": "No image",
    "noInsightsDataDescriptionString": "Please check the period and filters and try again.",
    "noInsightsDataForSelectedArticleDescriptionString": "No insights data available for the selected article. Please check the period, filters or try with another article.",
    "noInsightsDataString": "No insights data available",
    "noLocationsAvailableHelperString": "Type any grid to add location",
    "noLocationsAvailableString": "No locations added yet",
    "noLocationsAvailableTaskTypeString": "No locations available for the selected task type.",
    "noLocationsForArticleString": "No locations found for this article.",
    "noLocationsString": "No locations",
    "noLocationsTitleString": "No locations",
    "noMediasCreatedString": "There are no medias created in your store yet.",
    "noMoreArticlesAvailableString": "Not enough articles available for",
    "noMoreArticlesForHfbBody1": "There aren't enough articles to be tested for some of the HFB(s) you have selected.",
    "noMoreArticlesForHfbBody2": "The available amount of articles have already been part of a completed Tested buy today or there is less than {{articleCounts}}.",
    "noMoreArticlesForHfbBody3": "Please lower the amount of articles or start a new Test buy for those HFB(s) tomorrow.",
    "noMoreDigitsCanBeEntered": "No more digits can be added",
    "noMultiPackString": "It's not possible to order multi-packs because there's no information available about multi-pack size.",
    "noMultiPackTitleString": "No multi-pack size",
    "noNearbyAddonsContentString": "Tap here to add more",
    "noNearbyAddonsTitleString": "Are you missing a nearby add-on from the list?",
    "noneString": "None",
    "noOpenTasksString": "No open tasks",
    "noPalletString": "It's not possible to order pallets because there's no information available about pallet size.",
    "noPalletTitleString": "No pallet size",
    "noPermittedStores": "You do not have permissions to any stores. Request access from MyIdentity.",
    "noPhoneString": "There are no saved numbers",
    "noPqrTeamString": "No product quality team",
    "noProductQualityTeamString": "No Product Quality team found in store.",
    "noPtagsNeededString": "No P-tags needed",
    "noQuestionFound": "No questions found",
    "noQuestionsForString": "No questions for \"{{ query }}\".",
    "noResultsForMediaWithFiltersString": "There are no results for {{ name }} with your applied filters",
    "noResultsForString": "No results for “{{ query }}”.",
    "noResultsString": "No results found. Try again.",
    "noResultsWithFiltersString": "There are no results with your applied filters",
    "noRightPermissionsString": "You don't have the right permissions!",
    "noRolesFoundDescriptionString": "No roles found for the selected filters",
    "noRolesFoundString": "No roles found",
    "noRoomsCreatedString": "No room settings created. Please go to Fixa Admin to create a room setting.",
    "noRoomSettingsCreatedString": "There are no room settings created in your store yet.",
    "noSearchResultsForQueryString": "There are no search results for {{ query }}",
    "noSearchResultsInMediaString": "There are no search results for {{ query }} in {{ name }}",
    "noSearchResultsInMediaWithFiltersString": "There are no search results for {{ query }} in {{ name }} with your applied filters",
    "noSearchResultsString": "There are no results for \"{{ query }}\"",
    "noSearchResultsWithFiltersString": "There are no search results for {{ query }} with your applied filters",
    "noStockInfoString": "No stock info",
    "noStoresMatching": "No matching stores.",
    "noString": "No",
    "noTaskResultsString": "No results",
    "noTasksAssignedYetString": "No tasks assigned yet",
    "noTasksAvailableString": "There are no tasks available",
    "noTaskSelectedString": "No task selected",
    "noTasksFiltersString": "There are no tasks based on your filters",
    "noTasksFoundString": "No tasks found",
    "noTasksWithAppliedFiltersString": "No tasks with applied filters",
    "notCompleteWeekWarning": "not a complete week",
    "noTeamsDescriptionString": "No teams for the selected store and filters.",
    "noTeamsInStoreString": "No teams in store",
    "noTeamsMessageString": "No teams have been created for your store yet. Try to login again after a super user has created teams that you can join.",
    "noTeamsString": "No teams",
    "noteFromString": "Note from {{name}}",
    "noTestbuysYetString": "No test buys yet",
    "notFoundString": "Search instead",
    "notGreatString": "Not great",
    "nothingString": "Nothing to see here",
    "nothingToShowString": "Nothing to show",
    "nothingToShowYetString": "Nothing to show yet",
    "notificationAnnouncementString": "You can now customize notifications.",
    "notificationInboxString": "Notification Inbox",
    "notificationPermissionDeniedString": "Push notifications are disabled on this device!",
    "notificationsEmptySubtitleString": "Nothing to see here",
    "notificationsEmptyTitleString": "There is no activity in your team yet.",
    "notificationSettingsString": "Notification settings",
    "notificationSettings_assigneesTitle": "Task assignees",
    "notificationSettings_eventsTitle": "Task events",
    "notificationSettings_otherNotificationsTitle": "Other notifications",
    "notificationSettings_remindersTitle": "Task reminders",
    "notificationSettings_testbuysTitle": "Test buy assignees",
    "notificationsSettingsString": "Notifications",
    "notificationsString": "Notifications",
    "notificationString": "Notification",
    "notInStockString": "Not in stock",
    "notInterestedString": "I'm not interested",
    "notOkWithNumberString": "Not okay ({{ count }})",
    "noToolString": "No tool",
    "noToolTakenString": "No tool taken",
    "notPartOfGroupString": "Not part of group",
    "notPossibleWithoutTeams2String": "It’s not possible to use Fixa without being in a team. Please visit the Fixa Admin for creating teams.",
    "notPossibleWithoutTeams3String": "It’s not possible to use Fixa without being in a team. Use the Team Management page to administer teams.",
    "notPossibleWithoutTeamsString": "It’s not possible to use Fixa without being in a team. Please reach out to a country super user for creating teams.",
    "notSetString": "Not set",
    "notSpecifiedString": "Not specified",
    "notStartedString": "Not started",
    "notStockTitle": "Not in stock",
    "notVisibleUntilYouChangeBackString": "They will not be visible until you change back to this store",
    "noUnreadString": "That's everything! No new comments to see here.",
    "noUsersInStoreDescriptionString": "There are no users in the selected store and filters.",
    "noUsersInStoreString": "No users in {{ storeName }}",
    "noUsersInTeamDescriptionString": "There are no users in the selected team. Please select another team or clear the filters.",
    "noUsersInTeamString": "No users in {{ teamName }}",
    "noVariantsString": "No variants available",
    "novemberString": "November",
    "nTasksChangedString": "{{count}} tasks changed",
    "nTasksNotChangedString": "{{ number }} out of {{ count }} tasks were changed.",
    "nthString": "{{count}}th",
    "numberCanOnlyBeNDigits": "You have entered {{ length }} digits!",
    "numberOfArticlesAreDamagedInMediaString_one": "{{ count }} article is damaged in media",
    "numberOfArticlesAreDamagedInMediaString_other": "{{ count }} articles are damaged in media",
    "numberOfArticlesAreMissingInMediaString_one": "{{ count }} article is missing in media",
    "numberOfArticlesAreMissingInMediaString_other": "{{ count }} articles are missing in media",
    "numberOfArticlesNeedsPtagInMediaString_one": "{{ count }} article needs new P-tag in media",
    "numberOfArticlesNeedsPtagInMediaString_other": "{{ count }} articles need new P-tags in media",
    "numberOfArticlesOptionalString": "Number of articles (optional)",
    "numberOfArticlesString": "Number of articles",
    "numberOfArticlesToChangeInMediaString_one": "Change {{ count }} article in media",
    "numberOfArticlesToChangeInMediaString_other": "Change {{ count }} articles in media",
    "numberOfArticlesToRemoveInMediaString_one": "Remove {{ count }} article in media",
    "numberOfArticlesToRemoveInMediaString_other": "Remove {{ count }} articles in media",
    "numberOfPhotosString": "{{number}} photos",
    "numberOfRefillLocationsString": "Number of refill locations",
    "octoberString": "October",
    "offlineModeString": "Offline mode",
    "offlineString": "You're offline",
    "ofString": "of",
    "ofWhichRecentlyClosedString": "{{ count }} of which recently closed",
    "okIUnderstandString": "Ok, I understand",
    "okiunderstandString": "Ok, I understand",
    "OkString": "Ok",
    "okWithNumberString": "Okay ({{ count }})",
    "oldestFirstString": "Oldest first",
    "onDateString": "On {{date}}",
    "oneArticleNumberPerLineString": "One article number per line",
    "oneArticlePerLineString": "1 article per line",
    "oneDayOverdueString": "1 day overdue",
    "oneNotAtAllString": "1 = Not at all ",
    "onePersonString": "One person working here today",
    "onePhotoString": "1 photo",
    "oneTaskAssignedToYouString": "There are 1 task assigned to you in this store",
    "ongoingString": "Ongoing",
    "ongoingTasksAriaLabelString": "{{count}} Ongoing tasks",
    "ongoingTasksString": "Ongoing tasks",
    "ongoingTaskString": "Ongoing task",
    "ongoingTestBuyString": "You already have an ongoing test buy",
    "onlyAvailableBetweenString": "Only available between",
    "onlyNumericalCharactersAllowedForPinString": "Only numerical characters are allowed for the PIN code.",
    "onlyOnePQTeam": "Only one Product Quality team is allowed in a store.",
    "onlyOneProductQualityTeamAllowedString": "An active product quality team already exists.",
    "onlyQuestionsTasksString": "Only questions tasks",
    "onlyQuestionsWithTasksString": "Show only questions with tasks.",
    "onlyRecentlyClosedString": "{{ count }} recently closed tasks",
    "onlyVisibleToYouString": "Only visible to you",
    "onTheString": "On the",
    "onThisDaysString": "On these days",
    "oops": "Oops",
    "openLinkString": "Open link",
    "openTasks1String": "<b>Swipe the task all the way</b> to the right to pick up the task, and <b>swipe right half way</b> to see the Pick Up task option. When picked up, the task is moved to My task list.",
    "openTasks2String": "<b>Swipe left</b> and tap more to get the option to edit, close or reassign the task.",
    "openTasks3String": "<b>Alternatively</b>, tap on a task to get a detailed view, edit or pick up the task.",
    "openTasksContentString": "Tasks assigned to your team and ready to be picked up.",
    "openTasksString": "Open tasks",
    "optionalColonString": "Optional:",
    "optionalString": "Optional",
    "ordinalastString": "last",
    "ordinalfirstString": "first",
    "ordinalfourthString": "fourth",
    "ordinallastString": "last",
    "ordinalsecondString": "second",
    "ordinalthirdString": "third",
    "orString": "Or",
    "otherAreaAsIsString": "AsIs",
    "otherAreaBarString": "Bar",
    "otherAreaBistroString": "Bistro",
    "otherAreaCashlineString": "Cashline",
    "otherAreaCheckoutString": "Checkout",
    "otherAreaClickAndCollectString": "Click and Collect",
    "otherAreaCustomerServiceAreaString": "Customer service area",
    "otherAreaCustomerServiceString": "Customer service",
    "otherAreaDriveThruString": "Drive thru",
    "otherAreaEntranceInclGreeterString": "Entrance (Incl. Greeter)",
    "otherAreaFinancingArea": "Financing area",
    "otherAreaFinancingAreaString": "Financing area",
    "otherAreaFirstRoomString": "First room",
    "otherAreaFullServeHandoutsString": "Full Serve Handouts",
    "otherAreaFullServeHandoutString": "Full Serve Handout",
    "otherAreaGreetingAreaString": "Greeting area",
    "otherAreaHomeDeliveryString": "Home Delivery",
    "otherAreaHomeServicePointPlanningStudioString": "Home Service Point – Planning studio",
    "otherAreaIkeaForBusinessString": "Ikea for business",
    "otherAreaIKEAForBusinessString": "IKEA for Business",
    "otherAreaIkeaRestaurantString": "IKEA Restaurant",
    "otherAreaIKEARestaurantString": "IKEA Restaurant",
    "otherAreaIngkaCentersString": "Ingka Centers",
    "otherAreaLaunchAreaString": "Launch area",
    "otherAreaOpenTheWalletMarkethallString": "Open the wallet Markethall",
    "otherAreaOpenTheWalletShowroomString": "Open the wallet Showroom",
    "otherAreaOpenTheWalletString": "Open The Wallet",
    "otherAreaParkingZoneString": "Parking zone",
    "otherAreaPickUpPointHubString": "Pick-up point/hub",
    "otherAreaQuestionsFromCoWorkersString": "Questions from co-workers",
    "otherAreaRecoveryString": "Recovery",
    "otherAreaRestaurantString": "Restaurant",
    "otherAreaSelfServeString": "Self-serve",
    "otherAreaSmålandString": "Småland",
    "otherAreaSmalandString": "Småland",
    "otherAreaStairsString": "Stairs",
    "otherAreaSwedishFoodMarketString": "Swedish Food Market",
    "otherHFBs2String": "OTHER HFB",
    "otherHFBsString": "Other HFBs",
    "otherLocationsString": "Sales locations",
    "otherString": "Other",
    "otherTeamsString": "Other teams",
    "outdatedImagesString": "Outdated images",
    "outdoorBalconyString": "Outdoor / Balcony",
    "outgoingEdsString": "Outgoing EDS",
    "outgoingProductString": "Outgoing",
    "outOfStockString": "Out of stock",
    "outOfStockTitle": "Out of stock",
    "outOfStockWarningDescriptionString": "Do you wish to create this order anyway? We suggest creating an Out of Stock issue instead.",
    "outOfStockWarningTitle": "This article is out of stock",
    "overdueString": "Overdue",
    "ownBagString": "Own bag",
    "packageDimensionsString": "Package dimensions",
    "packagesString": "Packages",
    "palletSettingsTitleString": "Pallet settings",
    "palletSettingsUnit": "pieces/pallet",
    "palletsString": "Pallets",
    "palletString": "Pallet",
    "palletsUnit": "pallets",
    "palletTitleString": "Pallet ({{ count }})",
    "palletUnit": "pallet",
    "partialAmountString": "Confirm the refilled amount",
    "partialPickedAmountString": "Confirm the picked amount",
    "partOfLocalCombinationString": "Part of Local combination",
    "passedSalesDescriptionString": "Total sum of articles that passed in this test buy",
    "passedSalesString": "Passed sales",
    "passedString": "Passed",
    "passRatioString": "Pass ratio",
    "pastEdsString": "Past EDS",
    "pcsString": "pcs",
    "pedsDatesString": "Past EDS dates",
    "peoplePlanetString": "People & Planet",
    "peopleString": "{{ teamNumber }} people working here today",
    "percentageFromString": "Percentage from",
    "percentagePassedInString": "Percentage passed in {{ month }}",
    "periodString": "Period",
    "phoneString": "Phone numbers",
    "photoPrivacyTextString": "Be mindful of others’ privacy. When taking or uploading photos, please avoid capturing other people or sensitive data.",
    "photosString": "Photos",
    "photoString": "{{count}} Photo",
    "photoString_plural": "{{count}} Photos",
    "photoString_other": "{{count}} Photos",
    "picked2String": "picked",
    "pickedLowercaseString": "picked",
    "pickedString": "Picked",
    "pickedTaskString": "You picked up the task.",
    "pickedUpTaskString": "Picked up task",
    "pickedUpTheTaskString": "picked up the task",
    "pickedUpTheTaskStringCapitalized": "Picked up the task",
    "pickingDetailsString": "Confirm picking details",
    "pickingFilterString": "Filter by picking location",
    "pickingLocation2String": "Picking location",
    "pickingLocationString": "Picking location",
    "pickingNotification2String": "You completed picking, and handed the task off for refilling",
    "pickingNotificationString": "You completed picking",
    "pickingOnlyString": "Picking only",
    "pickingOnlyTextString": "Turn this on if you will only pick these items, and another co-worker will be responsible for placing them in their final refill location.",
    "pickTasksString": "Pick up tasks",
    "pickupAndRefillLocationCannotBeSameString": "Pick up and refill location cannot be the same",
    "pickupAtString": "Pick-up at",
    "pickupErrorMessage": "Error picking up task",
    "pickupGridCodeAscendingString": "Pickup grid code ascending",
    "pickupGridCodeDescendingString": "Pickup grid code descending",
    "pickupLocation": "Pickup location",
    "pickupLocationString": "Select pickup location",
    "pickupPQ1String": "All PQ reports show up in <b>Open Tasks</b>. You can swipe them to pick them up.",
    "pickupPQ2String": "Alternatively, you can look at the details and then pick the report up.",
    "pickupPQ3String": "Once you pick up the report, you will find them under the <b>My Tasks</b> tab.",
    "pickupPQ4String": "After reviewing the report, you can either accept or decline.<br/><br/>Use <b>Accept</b> when it’s reported into the CASY deviation system.<br/>Use <b>Decline</b> when it doesn’t fulfil the product quality deviation criteria.",
    "pickupPQ5String": "Enter a reason for accepting or declining the issue report. Pressing <b>Close issue</b> or <b>Accept issue</b> will add a comment to the task and notify the co-worker.",
    "pickupPQ6String": "You’ll find the accepted and declined PQ reports in the <b>Activity tab</b>, under the <b>Closed</b> category.<br/>All accepted reports need to be logged in the Store's external PQ Report list for later reference.",
    "pickupProductQualityReportContentString": "For Product Quality team: Pick up and follow up on Product Quality issues.",
    "pickupProductQualityReportIngress2String": "If you’re in the PQ team, you can pick up Product Quality (PQ) reports and then either accept or decline them. The co-worker who created the report will be notified automatically.",
    "pickupProductQualityReportShortString": "Pick up a PQ report",
    "pickupProductQualityReportString": "Pick up Product Quality report",
    "pickUpString": "Pick up",
    "pickUpTask": "Why not pick up an open task?",
    "pickupTaskButton": "Pickup task",
    "piecesAddedString": "{{ count }} pieces added",
    "piecesContributionActionLabel": "View est. turnover",
    "piecesContributionTitle": "Contribution (Pieces)",
    "piecesCountString": "{{ count }} piece",
    "piecesCountString_plural": "{{ count }} pieces",
    "piecesCountString_other": "{{ count }} pieces",
    "piecesInDifferentMediaString": "{{ pieces }} pieces in {{ count }} different media",
    "piecesMultiPackString": "Pieces/Multipack",
    "piecesPalletString": "Pieces/Pallet",
    "piecesPerMultiPackString": "Pieces per multi-pack",
    "piecesPerPalletString": "Pieces per pallet",
    "piecesString": "Pieces",
    "piecesTitleString": "Pieces",
    "piecesUnit": "pieces",
    "pieceUnit": "piece",
    "pinCodesDidNotMatchString": "PIN codes did not match.",
    "pinCodeString": "PIN code",
    "pinYouEnteredIsIncorrectString": "The PIN you've entered is incorrect - please try again.",
    "placeholder2String": "Note",
    "placeholderString": "Anything we can improve?",
    "plannedPreviewString": "Set to {{date}}",
    "plannedString": "Planned",
    "plannedSummaryString": "This task will appear in the task list on {{date}}.",
    "plannerCodeString": "Planner code",
    "pleaseAddAtLeastArticlesString": "Please add at least {{count}} article(s).",
    "pleaseAddCommentString": "Please add a comment",
    "pleaseCenterCameraBarcodeScanString": "Please center the camera on the barcode to scan.",
    "pleaseDecideWhatTodoWithTasksString": "Please decide what to do with the tasks before changing store.",
    "pleaseEnterYourCurrentPINCodeString": "Please enter your current PIN code.",
    "pleaseFillInString": "Please fill in",
    "pleaseMakeASelectionString": "Please make a selection",
    "pleaseMarkAllTasksTack": "Please make sure all finished tasks are marked as complete. Tack!",
    "pleaseRefreshApplicationString": "Please refresh the application to try again.",
    "pleaseSelectADifferentArticleString": "Please select a different article",
    "pleaseSelectAReasonString": "Please select a reason",
    "pleaseSelectAStoreString": "Please select a store",
    "pleaseSelectATeamString": "Please select a team",
    "pleaseSelectDateString": "Please select a date",
    "pleaseSelectOptionToContinueString": "Please select an option to continue",
    "pleaseSelectString": "Please select",
    "pleaseUseScannerPageDescriptionString": "You can now use the scanner page to scan articles in Coworker hub. Go back to the scanner page and try to scan there.",
    "pleaseUseScannerPageString": "Please use the scanner page to scan articles",
    "pleaseUseSideButtonScanString": "Please use a side button to scan",
    "positiveContinueString": "Yes, continue",
    "pqAssembleString": "I assembled the product",
    "pqCustomerInformedString": "A customer informed me of it in the store",
    "pqCustomerToldString": "A customer told me",
    "pqdAPartsBroken": "Parts broken",
    "pqdAPartsMissing": "Parts missing",
    "pqdAPoorWelding": "Poor welding",
    "pqdAssembly": "Assembly",
    "pqdAWrongDimensions": "Wrong dimensions",
    "pqdAWrongDrilling": "Wrong drilling",
    "pqDisplayItemString": "It was a display item",
    "pqdLabels": "Labels",
    "pqdLFCrackingBreaking": "Cracking/Breaking",
    "pqdLFCrackingBreakoing": "Cracking/Breaking",
    "pqdLFDents": "Dents",
    "pqdLFLooseThread": "Loose thread",
    "pqdLFPoorLaquering": "Poor lacquering",
    "pqdLFSpotsStains": "Spots/Stains",
    "pqdLLabelComesOffTooEasily": "Label comes off too easily",
    "pqdLLabelMissing": "Label missing",
    "pqdLLabelPlacedIncorrectly": "Label placed incorrectly",
    "pqdLLabelToHardToRemove": "Label too hard to remove",
    "pqdLookAndFeel": "Look and feel",
    "pqdLWrongUnreadableLabel": "Wrong/undreadable label",
    "pqdOProductIsUnstable": "Product is unstable",
    "pqdOSmellOdour": "Smell/odour",
    "pqdOSoundNoice": "Sound/noise",
    "pqdOWronSizeShape": "Wrong size/shape",
    "pqdPackaging": "Packaging",
    "pqdPIUnclearProductInfo": "Unclear product info",
    "pqdPIWrongProductInfo": "Wrong product info",
    "pqdPIWrongProductInfoInCatalogue": "Wrong product info in catalogue",
    "pqdPIWrongProductInfoOnline": "Wrong product info online",
    "pqdPMElectricPartsNotWorking": "Electric parts not working",
    "pqdPMElectricPartsStoppedWorking": "Electric parts stopped working",
    "pqdPMLeakageAfterUsage": "Leakage after usage",
    "pqdPMMechanicalPartsNotWorking": "Mechanical parts not working",
    "pqdPMMechanicalPartsStopperWorking": "Mechanical parts stopped working",
    "pqdPPackagingBreaks": "Packaging breaks",
    "pqdPPackagingHardToHandle": "Packaging hard to handle",
    "pqdPPackagingHardToTransport": "Packaging hard to transport",
    "pqdPPackagingNotProtectingProduct": "Packaging not protecting product",
    "pqdPPackagingOpens": "Packaging opens",
    "pqdProductInformation": "Product information",
    "pqdProductMalfunction": "Product malfunction",
    "pqdSelectTagsThatMatchTheProblem": "Select tags that match the problem",
    "pqdSelectTypeOfProblem": "Select type of problem",
    "pqInTheLocationString": "In the sales location / Showroom",
    "pqQustomerReturnedString": "A customer returned it",
    "pqReportBeingSentString": "Your report is sent to the Product Quality (PQ) team.",
    "pqReportConcludedString": "Your report is accepted or closed.",
    "pqReportPickedUpString": "Your report is picked up by the PQ team.",
    "pqReportTitleString": "Your report is sent to the Product Quality team.",
    "pqrErrorModalBodyString": "To add a product quality team please talk to your store owner",
    "pqrErrorModalTitleString": "It seems you do not have a product quality team in your store",
    "pqrFeedbackExplanationString": "Describe how you will proceed with this report",
    "pqrFeedbackTitleString": "Feedback",
    "pqSalesLocationString": "In the sales location",
    "pqUnpackOrAssembleString": "I unpacked / assembled the product",
    "pqUnpackString": "I unpacked the product",
    "previewString": "Preview",
    "previewThisTask": "Preview of this task",
    "previous": "Previous",
    "previousImageString": "Previous image",
    "previousTertialString": "Previous tertial",
    "priceLevelCannotBeEmptyString": "Price level cannot be empty",
    "priceLevelString": "Price level",
    "priceNotSet": "(price not set)",
    "priceQT": "Price",
    "primaryLocationString": "Primary location",
    "primaryReasonScoreString": "What is the primary reason for your score?",
    "primaryString": "Primary",
    "printPtagForArticleInRoomString": "Print p-tag for article in {{ room_name }}",
    "printPtagInRoomString": "Print p-tag in {{ room_name }}",
    "printPTagsString": "Print p-tag(s)",
    "printPTagString": "Print p-tag",
    "priority2String": "Priority flag",
    "priorityCannotBeEmptyString": "Priority cannot be empty",
    "priorityFirstString": "Priority first",
    "priorityString": "Priority",
    "priorityTasksOnlyString": "Priority tasks only",
    "privacyStatementDataCollectionIntroString": "When you use Fixa, the Ingka Group company Data Controller will collect certain personal data about you. For questions to this, reach out to <1>{{email}}</1> or your local privacy policy leader.",
    "privacyStatementDataControllerTextString": "Local/Country Ingka Entity/Company is the controller of your personal data. Please reach out to us for information about the local data controller or if you have any questions.",
    "privacyStatementDataControllerTitleString": "The data controller for this processing of personal data is:",
    "privacyStatementDataStoredText1String": "We store finished tasks with references to users for 30 days, whereafter they are anonymised. A co-worker's personal data is stored in Fixa for the duration of the employment contract.",
    "privacyStatementDataStoredText2String": "Termination of employment contract with Ingka Group: All personal data is being automatically deleted within 1 month after the Coworker profile has been removed.",
    "privacyStatementDataStoredText3String": "Personal Data may also be removed at any point in time upon request to the local Information Security and Data Privacy Leader or Store Manager.",
    "privacyStatementDataStoredText4String": "The hashed/pseudonymised data passed to Pendo will be stored for 2 years in Pendo.",
    "privacyStatementDataStoredTitleString": "The data will be stored:",
    "privacyStatementFixaTeamString": "Fixa team:",
    "privacyStatementIntroString": "Fixa is a task management and merchandising tool for in-store co-workers. The FIXA application's purpose is to replace manual, paper or excel based activities and streamline task management in store (refilling articles, clean ups, deviations, test buys, most frequently asked questions etc). Fixa also allows for analytics through insights gained from completed tasks.",
    "privacyStatementLegalGroundTextString": "The legal ground for the processing is legitimate interest.",
    "privacyStatementLegalGroundTitleString": "The legal ground for the processing is:",
    "privacyStatementPersonalDataCollectedText1String": "When you use FIXA, the system will collect information about you from the global coworker database such as your First name, last name, email, job title, role, phone number (if manually provided - personal phone number should not be entered), language preference in app, store ID, country ID, IP-address processed in Google Cloud Platform, Sentry (Sentry is an application error tracking software) and Pendo (co-worker experience platform)",
    "privacyStatementPersonalDataCollectedText2String": "Co-worker profile is automatically created through when you login to Fixa for the first time. Personal data is fetched from the global coworker database.",
    "privacyStatementPersonalDataCollectedTitleString": "The personal data collected is:",
    "privacyStatementPurposeTextString": "The purpose of the personal data collection in Fixa is for the application to function properly in a way that enables easy internal communication between co-workers and administrate tasks between co-workers in the store. Having tasks connected to a user enables us to support notifications for updates on tasks for assigned users and creators.",
    "privacyStatementPurposeTitleString": "The purpose of collecting this data is:",
    "privacyStatementRightsTextString": "You have certain rights in relation to your personal data. Please visit <1>this page</1> to learn more about such rights.",
    "privacyStatementTitleString": "Privacy statement",
    "privacyString": "Privacy policy",
    "problemAddingThisUserTryAgainString": "There was a problem adding this user. Please try again.",
    "problemEditingThisUserTryAgainString": "There was a problem editing this user. Please try again.",
    "product2String": "Product",
    "productAlreadyExistInRoomString": "This product already exists in this room",
    "ProductAttributesString": "Product attributes",
    "productDamagedOrBrokenString": "Product damaged or broken",
    "productDetailsString": "Product details",
    "productDimensionsString": "Product dimensions",
    "productInformationString": "Product information",
    "productLocationDetailsTitle": "Details",
    "productNumberString": "Product number",
    "productQualityLocationsString": "Product Quality Locations",
    "productQualityReportString": "Product Quality report",
    "productQualityTeamString": "Product Quality Team",
    "productRangeString": "Product range",
    "productSelectionString": "Product selection",
    "productString": "Product Issue",
    "productVariantsDescriptionString": "Color, Size",
    "productVariantsString": "Product variants",
    "profileString": "Profile",
    "profitAceString": "Ace 2: Profit",
    "ProfitString": "Ace 2: Profit",
    "proofOfCompletionString": "Proof of completion",
    "proofOfCompletionSubmittedString": "Proof of completion submitted",
    "ptagsCountString": "{{ count }} P-tags",
    "ptagsCountString_other": "{{count}} p-tags",
    "pTagsString": "Get {{ count }} P-tag(s)",
    "pTagsString_one": "{{ count }} P-tag",
    "pTagsString_other": "{{ count }} P-tags",
    "pTagsString_zero": "No P-tags",
    "publicationString": "Publication",
    "publicString": "Public location",
    "publishedDateString": "Published {{date}}",
    "publishedString": "Published",
    "publishString": "Publish",
    "qtyString": "Qty",
    "qualitativeGoalString": "Qualitative goal",
    "quantityCannotExceedExistingAmountString": "The quantity cannot exceed the existing amount in each media.",
    "quantityString": "Quantity",
    "quantity_typeString": "Quantity type",
    "question2String": "Are you sure?",
    "questionsAskedString": "Questions asked",
    "questionStringMFAQ": "Question",
    "questionSucessfullyCreatedString": "Your question has been added and upvoted.",
    "questionsWithTasksOnlyString": "Questions with tasks only",
    "quickActionsString": "Quick actions",
    "rackingIssueString": "Racking issue",
    "randomizeString": "Randomize",
    "randomString": "Random",
    "randomTypeOfArticleSubTextString": "Now with improved article selection!",
    "rangeDescription2String": "Range sequence/structure",
    "rangeDescriptionString": "Range description",
    "rankingString": "Ranking",
    "readAllString": "Read All",
    "readInstructionsString": "Discover how to use Fixa effectively",
    "readMoreString": "Read more",
    "readReleaseNotesString": "New version released. View release notes.",
    "readyToScanString": "Ready to scan",
    "reasonEnsureString": "<b>Ensure customer satisfaction</b> by effectively keeping additional sales locations refilled.",
    "reasonForChangeString": "Reason for change",
    "reasonImproveAddonSalesString": "<b>Improve your add-on sales</b> by using insights to make data-informed decisions for articles and sales locations.",
    "reasonInMediaNameString": "{{ reason }} in {{ mediaName }}",
    "reasonLessWorkString": "<b>Less manual work</b> to get insights and estimated turnover for add-on sales.",
    "reasonSaveTimeString": "<b>Save time</b> on your daily tasks by making them digital, optimised and easy to share with your <b>colleagues</b>.",
    "reasonString": "Reason",
    "reassignAllTasksToMyTeamString": "Reassign all tasks to my team",
    "reassignedNTasksString": "{{count}} task reassigned",
    "reassignedNTasksString_plural": "{{count}} tasks reassigned",
    "reassignedNTasksString_other": "{{count}} tasks reassigned",
    "reassignedTaskToNameString": "Reassigned task to {{ name }}",
    "reassignedTaskToString": "Reassigned task to {{ params.0 }}",
    "reassignNTasksToNameString": "You're about to reassign {{count}} tasks to {{name}}",
    "reassignString": "Reassign",
    "reassignTasksString": "Reassign tasks",
    "reassignTaskString": "Reassign task",
    "reassignToString": "Reassign to",
    "receiptString": "Receipt",
    "recentlyClosedTasksString": "Recently closed tasks",
    "recurringNotReadyString": "You have to select at least one day in a week to schedule a task.",
    "recurringPreviewHintString": "Every week on {{days}}",
    "recurringPreviewHintString_plural": "Every {{count}} weeks on {{days}}",
    "recurringPreviewHintString_other": "Every {{count}} weeks on {{days}}",
    "recurringString": "Recurring",
    "recurringSummaryString": "This task will appear in the task lists every week on {{days}} from {{start}} until {{end}}.",
    "recurringSummaryString_plural": "This task will appear in the task lists every {{count}} weeks on {{days}} from {{start}} until {{end}}.",
    "recurringSummaryString_other": "This task will appear in the task lists every {{count}} weeks on {{days}} from {{start}} until {{end}}.",
    "refillAlreadyRequestedString": "Refill already requested",
    "refillAndPickupIdenticalString": "Refill and pick-up can not be the same location.",
    "refillAreaIdString": "Refill area",
    "refillAreasString": "Refill areas",
    "refillAtString": "Refill at",
    "refillCorrectedTaskString": "corrected refill quantity",
    "refilled2String": "refilled",
    "refilledAreaInsightsString": "Refilled Area",
    "refilledByMeString": "Mark as refilled by me",
    "refilledLowercaseString": "refilled",
    "refilledSalesLocationIDInsightsString": "Refilled Sales Location ID (SLID)",
    "refilledSomethingString": "{{formattedAmount}} REFILLED",
    "refilledString": "Refilled",
    "refillFilterString": "Filter by refill location",
    "refillGridCodeAscendingString": "Refill grid code ascending",
    "refillGridCodeDescendingString": "Refill grid code descending",
    "refillingDetailString": "Confirm refill details",
    "refillingLocationString": "Refilling location",
    "refillLocationString": "Select refill location",
    "refillLocString": "Refill location",
    "refillQuantityNotUpdatedString": "Refill quantity not updated",
    "refillQuantityString": "Refill quantity",
    "refillQuantityUpdateString": "Refill quantity updated!",
    "refillsNotEditable4WeeksString": "Refills older than 4 weeks are not editable",
    "refillsNotEditableString": "Refills older than 10 weeks are not editable",
    "refillsString": "Refills",
    "refillString": "Refill",
    "refillTypeFirstFillInfoString": "The first fill of article to add-on location. Refill will not be included in add-on insights nor in the turnover calculations.",
    "refillTypeFirstFillString": "First fill",
    "refillTypeRegularInfoString": "Regular refill of article to add-on location.",
    "refillTypeRegularString": "Regular",
    "refillTypeString": "Refill Type",
    "refineString": "Refine results",
    "reformedHfb61String": "Consumer Packaged Goods",
    "refreshingString": "Refreshing",
    "refreshString": "Refresh",
    "regularRefillString": "Regular refill",
    "rejectedString": "Rejected",
    "relatedRefillsSumSForLocationtring": "{{ count }} piece ordered for {{ gridcode }}",
    "relatedRefillsSumSForLocationtring_plural": "{{ count }} pieces ordered for {{ gridcode }}",
    "relatedRefillsSumSForLocationtring_other": "{{ count }} pieces ordered for {{ gridcode }}",
    "relatedRefillsSumString": "{{ count }} piece ordered",
    "relatedRefillsSumString_plural": "{{ count }} pieces ordered",
    "relatedRefillsSumString_other": "{{ count }} pieces ordered",
    "relatedTasksCountString": "{{ count }} related task",
    "relatedTasksCountString_plural": "{{ count }} related tasks",
    "relatedTasksCountString_other": "{{ count }} related tasks",
    "relatedTasksFallbackSummaryString": "Found {{count}} related task for this article.",
    "relatedTasksFallbackSummaryString_plural": "Found {{count}} related tasks for this article.",
    "relatedTasksFallbackSummaryString_other": "Found {{count}} related tasks for this article.",
    "relatedTasksIssueSummarySingleLocationString": "{{count}} {{issue}} task found in location {{locations}}.",
    "relatedTasksIssueSummarySingleLocationString_plural": "{{count}} {{issue}} tasks found in location {{locations}}.",
    "relatedTasksIssueSummarySingleLocationString_other": "{{count}} {{issue}} tasks found in location {{locations}}.",
    "relatedTasksIssueSummaryMultipleLocationsString": "{{count}} {{issue}} task found in locations {{locations}}.",
    "relatedTasksIssueSummaryMultipleLocationsString_plural": "{{count}} {{issue}} tasks found in locations {{locations}}.",
    "relatedTasksIssueSummaryMultipleLocationsString_other": "{{count}} {{issue}} tasks found in locations {{locations}}.",
    "relatedTasksString": "Related tasks",
    "releasedString": "You released the task",
    "releasedTheTaskString": "released and assigned to team \"{{team}}\"",
    "releaseNotesString": "Release notes",
    "releaseString": "Release task",
    "remaining": "Remaining",
    "removeLinkString": "Remove link",
    "removeOrderDescriptionString": "This task will be removed from your order.",
    "removeOrderString": "Remove from order",
    "removeProductInString": "Remove product in {{ room_name }}",
    "removeProductString": "Remove product",
    "removeString": "Remove",
    "removeThisNumberQuestion": "Remove this number?",
    "removeThisNumberString": "Remove this number",
    "renameYourFileToAcesandKingString": "Rename your file to AcesandKingsforallIngkamarkets.csv",
    "reopenedTaskString": "Reopened task",
    "reopenedTheTaskString": "reopened the task",
    "reopenString": "Reopen task",
    "repeatableString": "Set to repeat",
    "repeatedTaskString": "Repeated task",
    "repeatEveryString": "Repeat every",
    "repeatingTaskString": "Repeating task",
    "repeatMonthlyString": "Repeat monthly",
    "repeatOnDayOfMonthString": "Repeat on day {{date}} of the month",
    "repeatOnOfMonthString": "Repeat on {{value}} of the month",
    "repeatsDailyString": "Repeats daily",
    "repeatsMonthlyString": "Repeats monthly",
    "repeatsString": "Repeats",
    "repeatString": "Repeat",
    "repeatsWeeklyString": "Repeats weekly",
    "repeatTaskString": "Repeat task",
    "repeatWeeklyString": "Repeat weekly",
    "replaceArticleInRoomString": "Replace product in {{ room_name }}",
    "replaceArticleString": "Replace article",
    "replacedProductString": "Replaced product",
    "replaceProduct": "Replace product",
    "replaceWithNewProductInString": "Replace with a new product in {{ room_name }}",
    "replaceWithNewProductString": "Replace with a new product",
    "replaceWithString": "Replace with",
    "reportedByString": "Reported by",
    "request2String": "Request addon",
    "requestAccessString": "Request Access",
    "requested2String": "requested",
    "requested3String": "(Requested)",
    "requestedLowercaseString": "requested",
    "requestedString": "Requested",
    "requested_typeString": "Package type",
    "requestRefillString": "Request refill",
    "requestString": "Add-on request",
    "requiredFieldString": "This field is required",
    "requiredString": "Required",
    "resetFiltersString": "Reset filters",
    "resetOfPinCodeRequestedString": "Enter new PIN to reset your code.",
    "resetPinCodeString": "Reset PIN",
    "resetString": "Reset",
    "returnToHome": "Return to home",
    "roleString": "Role",
    "roomDeletedString": "Room deleted",
    "roomNameCannotBeEmptyString": "Room name cannot be empty",
    "roomNameString": "Room name",
    "roomsetSettingsString": "Roomset settings",
    "roomSettingCount": "room setting",
    "roomSettingNameString": "Room setting name",
    "roomSettingsCount": "room settings",
    "roomSettingsDisabledString": "Room settings is disabled",
    "roomSettingsPlacementString": "Room settings placements",
    "roomSettingsString": "Room settings",
    "roomsViewSearch": "Search for article or room setting",
    "roomWithNameAlreadyExistsString": "Room with name {{roomName}} already exists",
    "roundString": "Round",
    "safetyAlarmCheckboxHeaderString": "Does your report concern<br/>",
    "safetyAlarmCheckboxLine1String": "product safety,",
    "safetyAlarmCheckboxLine2String": "injuries,",
    "safetyAlarmCheckboxLine3String": "damage to property",
    "safetyAlarmCheckboxLine4String": "or product compliance?",
    "safetyAlarmHealthRelatedString": "(Example: injury or acute allergic reaction)",
    "safetyAlarmHealthRelatedTitleString": "Safety/Health related incidents or risks involving an IKEA product",
    "safetyAlarmLearnMoreString": "Learn more about safety alarm",
    "safetyAlarmLinkString": "Learn more about safety alarm",
    "safetyAlarmMarketRequirementsString": "(Example: confirmed or suspected non-compliance to a mandatory legal requirement for the import and placement of a product on a market, including identified voluntary safety standards)",
    "safetyAlarmMarketRequirementsTitleString": "Non-compliance to market requirements",
    "safetyAlarmPropertyDamageString": "(Example: when an IKEA product has been involved in or contributed to significant damage to property)",
    "safetyAlarmPropertyDamageTitleString": "Damage to property",
    "safetyAlarmReputationString": "(Example: attention in media/social media, contacts and/or questions from interest groups (NGO's), or authorities)",
    "safetyAlarmReputationTitleString": "Possible negative impact on IKEA reputation",
    "safetyAlarmRequiresString": "What requires a safety alarm?",
    "safetyAlarmString": "Safety alarm",
    "safetyAlarmText1String": "(Example: injury or acute allergic reaction)",
    "safetyAlarmText2String": "(Example: confirmed or suspected non-compliance to a mandatory legal requirement for the import and placement of a product on a market, including identified voluntary safety standards)",
    "safetyAlarmText3String": "(Example: attention in media/social media, contacts and/or questions from interest groups (NGO's), or authorities)",
    "safetyAlarmText4String": "(Example: when an IKEA product has been involved in or contributed to significant damage to property)",
    "safetyAlarmTitle1String": "Safety/Health related incidents or risks involving an IKEA product",
    "safetyAlarmTitle2String": "Non-compliance to market requirements",
    "safetyAlarmTitle3String": "Possible negative impact on IKEA reputation",
    "safetyAlarmTitle4String": "Damage to property",
    "safetyString": "Safety issue",
    "salesLocationInStoreString": "Sales location in store",
    "salesLocationsAndStockString": "Sales locations and stock",
    "salesLocationsString": "Sales locations",
    "salesLocationString": "Sales location",
    "salesStopString": "Sales stop",
    "salesString": "Sales location",
    "satString": "Sat",
    "saturdaysString": "Saturdays",
    "saturdayString": "Saturday",
    "save2String": "Save changes",
    "saveAndCompleteString": "Save and complete",
    "saveAndPickUpString": "Save and pick up",
    "savedForStoreString": "Saved for store",
    "savedString": "Saved",
    "saveString": "Save",
    "saveTaskString": "Save task",
    "scanAnotherString": "Scan another item",
    "scanArticleRDTString": "Scan article with RDT to add, or type",
    "scanMultipleTimesToIncreaseQuantityString": "Scan multiple times for increased quantity",
    "scannedArticleNumberIsNotValidString": "Scanned article number is not a numeric value: {{ articleNumber }}",
    "scannerBackButtonString": "Back to scan",
    "scannerFreeformTipString": "You can scan directly without tapping the search bar first.",
    "scannerReadyString": "Scanner ready",
    "scanProductBarcodeString": "Scan the product barcode or type in the product number manually.",
    "scanString": "Scan",
    "scanTip": "Tip: Steady camera for better scanning",
    "scheduledCustomTasks": "Scheduled custom tasks",
    "scheduledCustomTasksString": "Scheduled custom tasks",
    "scheduledCustomTaskString": "Scheduled custom task",
    "scheduledForString": "Scheduled for",
    "scheduledForTodayString": "Scheduled for today",
    "scheduledForTomorrowString": "Scheduled for tomorrow",
    "scheduledTasksString": "Scheduled tasks",
    "scheduledTaskString": "Scheduled task",
    "scheduleTaskForFutureString": "Schedule task for future",
    "scheduleTaskString": "Schedule task",
    "scrollLeftString": "Scroll left",
    "scrollRightString": "Scroll right",
    "searchArticleIdString": "Enter full article id",
    "searchArticleOrMedia": "Search for article or room setting",
    "searchArticleString": "Search article",
    "searchBasicString": "Search",
    "searchByEmailString": "Search by email",
    "searchContact": "Enter part of name or phone number",
    "searchCountryString": "Search country",
    "searchCoworkerString": "Search co-worker",
    "searchErrorMessage": "Unable to load search result",
    "searchErrorString": "Oops! Something went wrong",
    "searchFilterOptionsString": "Search {{title}}",
    "searchForArticlesInstructionsString": "Search for articles using article number or name.",
    "searchForArticlesString": "Search for articles",
    "searchForString": "Search for {{value}}",
    "searchHistoryString": "Search history",
    "searchInAllMediaString": "Search in All media",
    "searchLocationString": "Search location",
    "searchProdsAndLocsString": "Search products and locations",
    "searchQuestionString": "Search questions",
    "searchRefillAreaString": "Search refill area",
    "searchResultsString": "Search results",
    "searchResultString": "Search result: {{ count }}",
    "searchResultString_plural": "Search results: {{ count }}",
    "searchResultString_other": "Search results: {{ count }}",
    "searchStoreString": "Search store",
    "searchString": "Search products",
    "searchTeamString": "Search team",
    "searchUsersString": "Search users",
    "secondGroupingString": "Second grouping",
    "secondString": "2nd",
    "secondStringCapitalized": "Second",
    "seeAll2String": "See all",
    "seeAllString": "SEE ALL",
    "seeArticlesString": "See articles",
    "seeListOfSuperUsersString": "See list of super users",
    "seeOngoingOrCloseTestBuyString": "You can either see the ongoing test buy or close it by creating a new one",
    "seeOngoingString": "See ongoing",
    "seeRelatedTasksCountString": "See {{ count }} related task",
    "seeRelatedTasksCountString_plural": "See {{ count }} related tasks",
    "seeRelatedTasksCountString_other": "See {{ count }} related tasks",
    "seeTaskString": "See task",
    "seeTestbuyString": "See Test buy",
    "select2String": "select",
    "selectAllString": "Select all",
    "selectAreaBeforeSubmitString": "You must select area before creating question",
    "selectAreaString": "Select area",
    "selectArticleLocationString": "It’s not possible to select or search for locations before selecting an article",
    "selectArticlesString": "Select articles",
    "selectArticlesToContinueString": "Select articles to continue",
    "selectAtLeastOneDayToSaveString": "Select at least one day to save",
    "selectBackupProductString": "Select backup product",
    "selectCloseReasonString": "Select a reason for closing the task",
    "selectedCountString": "{{count}} selected",
    "selectedLocationString": "Selected location",
    "selectedNoParenthesesString": "Selected",
    "selectedString": "(Selected)",
    "selectedTeamString": "Selected team",
    "selectGroupString": "Select group",
    "selectHFBString": "Select HFB",
    "selectIssueString": "Select issue",
    "selectLocationBeforeSubmitString": "You must select location before creating question",
    "selectLocationString": "Select location",
    "selectMediaToContinueString": "Select media to continue",
    "selectMediaTypeString": "Select media type",
    "selectMoreFilters": "Too many results, please select more filters",
    "selectMultipleArticlesAndLocationsString": "Select multiple articles and refill locations in one go",
    "selectNewTeamString": "Select a new team",
    "selectOptionAllString": "{{title}}: All",
    "selectReasonClosingString": "Select a reason for closing the tasks",
    "selectReasonString": "Select reason",
    "selectRefillTypeString": "Select refill type",
    "selectRightCarrierInPtagString": "Select right carrier in PTAG",
    "selectRightCarrierInPTAGString": "Select right carrier in PTAG",
    "selectRoleString": "Select a role",
    "selectRoomsToAddString": "Select rooms to add",
    "selectSalesLocationString": "Select sales location",
    "selectStoreDescriptionString": "You can change stores later inside the app",
    "selectStoreString": "Select a store to continue",
    "selectString": "Select amount",
    "selectTaskTypeToFilterByLocationString": "Select a task type to filter by location",
    "selectTeamString": "Please select a team to join",
    "selectTypeOfTaskString": "Select type of task",
    "selfServeFurnitureAreaString": "Self-serve furniture area",
    "sendString": "Send feedback",
    "septemberString": "September",
    "serviceQT": "Service",
    "setAsMainImageString": "Set as main image",
    "setBackupArticleString": "Set backup article",
    "setForStoreText": "Set for Store",
    "setPinCodeString": "Set PIN code for RDT CT40 device",
    "setPtagsQuantityForMediaString": "Set p-tags quantity for media",
    "setString": "Set to repeat",
    "settingsString": "Settings",
    "setUpUpptackaHomeScreenString": "Set up Upptäcka home screen",
    "SFMString": "SFM",
    "sgfLocationsString": "SGF Locations",
    "sgfString": "SGF Location",
    "shareFeedbackString": "Share opinion",
    "sharingYourThoughtsString": "Sharing your thoughts help the Fixa team understand what we can improve on. Your feedback is anonymous.",
    "shiftHoursString": "Shift hours",
    "shiftString": "Your next shift is",
    "shoppingToolsHeaderString": "Shopping tools",
    "shoppingToolsProgress": "Progress",
    "shoppingToolsSessionIsString": "Shopping tools session is",
    "shoppingToolsString": "Shopping Tools",
    "shoppingToolSurveyString": "Shopping tool survey",
    "showCompleted": "Show {{ count }} completed",
    "showingNearbyAddonsString": "Showing only refills up to 21 days.",
    "showingSearchResults": "Search result for \"{{ query }}\" ({{ resultCount}})",
    "showingString": "Showing",
    "showOnlyDaysWithUpvotesString": "Show only days with upvotes",
    "showQuestionsToggleString": "Show questions only with task",
    "showroomEntranceString": "Showroom Entrance",
    "showroomOpenTheWalletString": "Showroom - Open the wallet",
    "showroomOTWString": "Showroom OTW",
    "showroomOWString": "Showroom OW",
    "showroomString": "Showroom",
    "showTaskString": "Show task",
    "singleMediaTaskString": "Single Media Task",
    "sizeString": "Size",
    "skipString": "Skip",
    "sliderHintString": "Drag the slider to desired value",
    "slidString": "SLID",
    "slowLoadingInfoString": "This is taking a bit longer than usual, but we’re still working on it...",
    "smarterTestbuyInformationDescriptionString": "Article selection for random Test buy has been improved for more relevancy. You can still swipe to get a new article or replace it manually.",
    "smarterTestbuyInformationTitleString": "Improved article selection",
    "smartString": "Smart",
    "soFarAboveLastWeekString": "{{formattedAmount}} ABOVE THE WEEK BEFORE",
    "soFarBelowLastWeekString": "{{formattedAmount}} BELOW THE WEEK BEFORE",
    "someFilesWereNotUploadedString": "One or more files were not uploaded. Only image files are allowed.",
    "someProductsSucceededString": "{{ count }}/{{ total }} products succeeded",
    "soonString": "COMING SOON",
    "sorrySomethingWentWrongString": "Sorry, something went wrong.",
    "sorryTaskCantBeCreatedString": "Sorry, task can’t be created",
    "sorryTaskCouldNotBeFoundString": "Sorry, task could not be found",
    "sorryTaskNotFoundString": "Sorry, this task could not be found",
    "sorryTwoLines": "Sorry. Something isn't quite right.\n Please try again later.",
    "sortByFilterTitleString": "Sort by: {{option}}",
    "sortByTitleString": "Sort by",
    "sortedByString": "Sorted by",
    "sortedByValueString": "Sorted by value",
    "soYouCantDeleteItString": "So you can’t delete it",
    "specificNeedToBeSolvedString": "Describe the specific need to be solved",
    "sprArticlesExcluded": "Please note that combined / \"SPR\" articles are currently excluded from the search.",
    "squareMetersString": "Square meters (m2)",
    "stageEnvironmentString": "TEST ENVIRONMENT",
    "staircaseString": "Staircase",
    "startDateString": "Start date",
    "startedByUserString": "Started by {{ user }}",
    "startInputString": "Start:",
    "startMultiOrderAddOnsString": "Start multi-order",
    "startNewTBString": "Start new Test buy",
    "startTestbuyString": "Start Test buy",
    "startToday": "Start today",
    "startTodayString": "Start today",
    "staticFilterRowAriaString": "Test buy created with",
    "statusOfString": "Status of {{name}}",
    "statusString": "Status",
    "stayOnPage": "Stay on page",
    "stepNumberString": "Step {{ number }}",
    "stock3String": "Stock",
    "stockDotString": "Stock.",
    "storeContacts": "Store contacts",
    "storeEnvironmentString": "Store environment",
    "storeNameString": "Store name",
    "storeOverviewString": "Store overview",
    "storeString": "Store contacts",
    "storeSuperUsersDescription": "Can help manage user profiles in the store",
    "storeSuperusersString": "Store Super users",
    "storeSuperuserString": "Store Super user",
    "strollerString": "Stroller",
    "styleGroupCannotBeEmptyString": "Style group cannot be empty",
    "styleGroupString": "Style group",
    "styleString": "Style",
    "submitCompletedTaskString": "Submit completed task",
    "submitNewString": "Submit & new",
    "submitPQ01String": "Tap on the Create Task button in the bottom navigation and select <b>Product Quality report</b> at the bottom of the list.",
    "submitPQ02String": "<b>Scan</b> the barcode of the product. When the product is registered, press <b>Continue</b>. Alternatively, you can also use the “Search products” bar at the top of the screen.",
    "submitPQ03String": "If the barcode wasn’t picked up from the scan, you need to provide the supplier number as well as the date stamp, photos, description and what’s been done so far.",
    "submitPQ04bString": "For the supplier number, you are <b>required</b> to enter 5 digits, which is the accepted format.<br />If you don’t know the supplier number, select the checkbox with the option <b>“I don’t have the supplier number”</b>. Please don’t enter a series of random numbers to the input field.",
    "submitPQ04String": "The <b>date stamp</b> and <b>supplier number</b> are found on the product label.",
    "submitPQ05String": "Take photos of the product to show the defect. It is good to include both a close-up photo and a photo showing the defect in the context of the entire product. <b>Important</b>: don’t include any sensitive data or capture any people in the pictures.",
    "submitPQ06aString": "Choose how you have discovered the issue. If you don’t find an appropriate option, select ‘Other’ to add a custom comment.",
    "submitPQ06String": "Describe the problem with the product. Try to be concise but descriptive.",
    "submitPQ07aString": "Describe the problem with the product.<br />Start by selecting the <b>type of problem</b> that best describes it according to you.",
    "submitPQ07bString": "Once you have selected the type of problem, you will be able to continue and describe the problem. Be concise but descriptive.<br/><br/>In addition, you will be able to select tags that helps describe the problem further. These tags are specific to each type of problem, so if you don’t see something that fits - you can try to go back and select another type of problem.<br/><br/>The selection of tags is optional. So you can continue without selecting anything.",
    "submitPQ07String": "Choose how you have discovered the issue. If you can’t find an appropriate option, select ‘Other’ to add a custom comment.",
    "submitPQ08aString": "Enter the location that the <b>defect</b> products are located.",
    "submitPQ08bString": "If the defect products are located at a sales location, you can select the corresponding sales location grid code if you know it.",
    "submitPQ08cString": "You can also enter a custom description of the location and it will be saved and you can select it the next time.",
    "submitPQ08String": "Describe what you've done to resolve the issue so far. If you have moved the affected product to a specific location, make sure to write it here.",
    "submitPQ09String": "If everything is correct on this summary screen, press <b>Create task</b> to send the report to the PQ team.",
    "submitPQ09whatString": "Describe what additional actions you have taken to resolve the issue.",
    "submitPQ10String": "Once you send your report to the responsible Product Quality team, it will be reviewed and you will get a notification when it’s accepted or declined. You can view your submitted report in the <b>Activity</b> screen. Important: When your report has been accepted/declined, make sure to read the comments for potential follow-up steps.",
    "submitProductQualityReportContentString": "How to submit a Product Quality report when there’s a defect with a product.",
    "submitProductQualityReportIngress2String": "If there is a Product Quality defect with a product, you can submit a Product Quality (PQ) report to have the problem inspected and resolved.",
    "submitProductQualityReportShortString": "Submit a PQ report",
    "submitProductQualityReportString": "Submit a Product Quality report",
    "submitSelectedTeamString": "Join selected team and continue",
    "submitString": "Submit",
    "submittingInProgressString": "Submitting ...",
    "successUserAddedString": "Success! This user has been added.",
    "successUserUpdatedString": "Success! This user has been updated.",
    "suggestedLocationsString": "Suggested Location names",
    "suggestionsString": "Suggestions",
    "sumFailedThisTestBuyString": "Total sum of articles that failed in this test buy",
    "sumForCustomDateString": "Estimated from refills on {{ start }} until {{ end }}",
    "sumFromMonToTodayString": "Estimated from refills",
    "sumFromString": "Sum from {{period}}",
    "sumFromWeekString": "Estimated from week {{formattedWeekNumber}} until today",
    "summaryString": "Summary",
    "sumPassedThisTestBuyString": "Total sum of passed in this test buy",
    "sundaysString": "Sundays",
    "sundayString": "Sunday",
    "sunString": "Sun",
    "superUsersString": "Super users",
    "supplierNumberString": "Supplier number",
    "support2021MessageString": "If you're experiencing technical issues with Fixa, please create a ticket through NowIT. For feedback and requests please send us an email at fixa.support@ikea.com.",
    "support2025MessageString": " If you are experiencing technical issues with Fixa, please create a ticket via",
    "supportMessageString": "For support adding co-workers, setting up teams, etc. please reach out to your store superusers.",
    "supportSettingsString": "Support settings",
    "supportString": "App support",
    "surelyDeleteArticleFromAllGroupsString": "{{ articleName }} will be deleted from {{ mediaName }} and from all groups",
    "surelyDeleteMedia2String": "Are you sure you want to delete {{ media }} <b>{{ item }}</b>?",
    "surelyDeleteMediaString": "Are you sure you want to delete the media <b>{{ item }}</b>?",
    "surelyDeleteRoomSettingString": "Are you sure you want to delete room setting <b>{{ item }}</b>?",
    "surelyDeleteString": "Are you sure you want to delete <b>{{ item }}</b>?",
    "surelyRemoveNumber": "Are you sure you want to remove this number?",
    "sureToContinueString": "Are you sure you want to continue?",
    "sureToDeleteGroupString": "Are you sure you want to delete the group named <b>{{ item }}</b>?",
    "sureToDeleteSelectedArticlesString": "Are you sure you want to delete the selected articles?",
    "surveyAvailabilityString": "Survey availability",
    "SustainabilityString": "Ace 4: Sustainability",
    "sustainableAceString": "Ace 4: Sustainable",
    "swipeLeftOrRightToReplaceString": "Swipe to left or right to replace any articles.",
    "swipeToReplaceArticlesString": "Swipe to replace articles",
    "switchCameraString": "Switch camera",
    "switchDescriptionString": "Did you remember to drop or reassign your tasks before switching? This will change which tasks you're able to see and pick up.",
    "switchedStoreToastMessageString": "Switched from {{ oldStore }} to store {{ newStore }}.",
    "switchString": "Switch teams?",
    "systemString": "System",
    "takString": "Tack! We will be reviewing all feedback as we continue to improve the experience.",
    "tapOnTheButtonToAddQuestion": "Tap on the button below to add your question.",
    "tapOnTheButtonToStartTestbuyString": "Tap on the button below to create a new test buy.",
    "task2String": "Task",
    "taskActionsString": "Task action",
    "taskAlreadyPickedUpString": "This task has already been picked up",
    "taskAssignedString": "Task assigned",
    "taskCannotBeCreatedWithPreFilledValuesString": "Task cannot be created with pre-filled values.",
    "taskCannotBeReopenedPleaseCreateNewTaskString": "Task can't be reopened, please create a new task",
    "taskClosedBecauseRemovedArticleString": "Task closed because the article was removed from the room.",
    "taskClosedBecauseRemovedRoomString": "Task closed because a room was removed.",
    "taskClosedString": "The task was closed",
    "taskCommentedString": "Task commented",
    "taskCompletedString": "Task completed",
    "taskCompletedWithChangesString": "Task completed with changes",
    "taskCreatedString": "Your task has been created",
    "taskCreatedString_plural": "Your {{ count }} tasks have been created",
    "taskCreatedString_other": "Your {{ count }} tasks have been created",
    "taskDescriptionString": "Task description",
    "taskDetailsString": "Task details",
    "taskEditedString": "Task edited",
    "taskErrorContentSubTitle": "No task found",
    "taskErrorContentTitle": "The task doesn't exist or you lack permission to see it",
    "taskErrorHeadingTitle": "Task",
    "taskErrorMessage": "Unable to load product",
    "taskHistoryString": "Task history",
    "taskIsAutoCompletedNoteString": "This task is auto generated to track actions done to an article in a media setting",
    "taskIsFourHoursOldString": "Priority task reminder",
    "taskIsOneDayOldString": "Task reminder",
    "taskIsScheduledDailySummaryText": "Task is scheduled for <b>{{start}}</b> and repeats once <b>every day</b>",
    "taskIsScheduledMonthlySummaryText": "Task is scheduled for <b>{{start}}</b> and repeats once every month on <b>{{recurrence}}</b>",
    "taskIsScheduledWeeklySummaryText": "Task is scheduled for <b>{{start}}</b> and repeats every week on <b>{{days}}</b>",
    "taskNotFoundString": "Task not found",
    "taskOngoingString": "Task ongoing",
    "taskOverviewString": "Task overview",
    "taskPickedUpString": "Task picked up",
    "taskReassignedString": "Task reassigned",
    "tasksAssignedToYouString": "There are {{ count }} tasks assigned to you in this store",
    "taskScheduledRepeatOnceEverydayString": "Task will be scheduled to repeat once <b>everyday</b>.",
    "tasksCreatedString": "Your task(s) were created",
    "tasksCreationFailedString": "Tasks creation failed, please try again.",
    "taskSeriesClosedByString": "Task series has been closed by {{ closedBy }}",
    "taskSeriesEndedString": "Task series has ended",
    "taskSeriesUpdatedByString": "Task series has been updated by {{ updatedBy }}",
    "taskSettingsString": "Task settings",
    "taskSettingString": "Task settings",
    "tasksSettingsString": "Tasks settings",
    "TasksString": "Tasks",
    "tasksString": "{{ count }} TASK",
    "tasksString_plural": "{{ count }} TASKS",
    "tasksString_other": "{{ count }} TASKS",
    "taskStatusString": "Task status",
    "tasksTodayString": "{{ number }} tasks today",
    "TaskString": "Task",
    "taskTitleString": "Task title",
    "taskTypeTitleAddon": "Add-on order",
    "taskTypeTitleBuy": "Buy",
    "taskTypeTitleCustom": "Custom",
    "taskTypeTitleDutyWalk": "Duty Walk",
    "taskTypeTitleProductAnalysis": "Product Analysis",
    "taskTypeTitleProductIssue": "Product Issue",
    "taskTypeTitlePTag": "P-Tag",
    "taskTypeTitleStoreIssue": "Store Issue",
    "taskViewString": "Task view",
    "taskWasClosedString": "Task closed",
    "task_typeString": "Task type",
    "tbAreBuyInstructionClear": "Are the buying instructions clear?",
    "tbAreBuyInstructionClearCheckString": "Buying instructions are clear",
    "tbClosed": "Test buy was successfully closed.",
    "tbCloseReasonAmount": "Wrong Amount",
    "tbCloseReasonHFB": "Wrong HFB",
    "tbCloseReasonNew": "New Test buy created",
    "tbDoesItHaveTag": "Does it have a clean and correctly placed price tag?",
    "tbDoesItHaveTagCheckString": "Article has a clean and correctly placed price tag",
    "tbIsItAvailableInIndicatedPosition": "Is it available at the indicated location?",
    "tbIsItAvailableInIndicatedPositionCheckString": "Article is available at the indicated location",
    "tbIsItCleanAndPerfect": "Is it clean and in perfect condition?",
    "tbIsItCleanAndPerfectCheckString": "Article is in clean and perfect condition",
    "tbIsItCleanAndPerfectDescription": "Fully functional and correctly assembled (if applicable)",
    "tbIsItDisplayed": "Is it displayed?",
    "tbIsItDisplayedCheckString": "Article is displayed",
    "tbIsItPlacedAndGroupInRangeArea": "Is it placed and grouped in a range area where a customer expects to find it?",
    "tbIsItPlacedAndGroupInRangeAreaCheckString": "Article is placed and grouped in a range area where a customer expects to find it",
    "tbNotOkay": "Not Okay",
    "tbNotOkayFixed": "Not okay, but fixed it immediately",
    "tbOkay": "Okay",
    "tbReassigned": "Test buy was successfully reassigned.",
    "tbTasksCompletedString": "{{ count }} task completed",
    "tbTasksCompletedString_plural": "{{ count }} tasks completed",
    "tbTasksCompletedString_other": "{{ count }} tasks completed",
    "tbTasksCreatedString": "{{ count }} task created",
    "tbTasksCreatedString_plural": "{{ count }} tasks created",
    "tbTasksCreatedString_other": "{{ count }} tasks created",
    "tbTasksPendingString": "{{ count }} task pending",
    "tbTasksPendingString_plural": "{{ count }} tasks pending",
    "tbTasksPendingString_other": "{{ count }} tasks pending",
    "teamClosedString": "Closed",
    "teamManagementString": "Team management",
    "teamMembersCountString_one": "{{ count }} team member",
    "teamMembersCountString_other": "{{ count }} team members",
    "teamNameString": "Team name",
    "teamOpenString": "Open",
    "teamsAdminString": "Teams Admin",
    "teamsInStore": "Teams: {{store}}",
    "teamsManagerString": "Teams Manager",
    "teamsString": "Teams",
    "teamString": "Team",
    "teamSuccessfullyCreatedString": "Team {{ teamName }} successfully created!",
    "teamSuccessfullyDeletedString": "Team {{ teamName }} successfully deleted!",
    "teamSuccessfullyUpdatedString": "Team {{ teamName }} successfully updated!",
    "teamTasksString": "Team tasks",
    "teamUnknownString": "unknown",
    "teamYourString": "your team",
    "tenMuchLikelyString": "10 = Extremely likely",
    "test": "Test",
    "testbuyCannotBeStartedDescriptionString": "Please try again later or create a new Test buy.",
    "testbuyCannotBeStartedString": "Test buy cannot be started",
    "testBuyDetailOptionsMenuAriaString": "Options menu for this test buy",
    "testBuyFollowUpString": "Test buy follow-up",
    "testBuyFollowUpTaskString": "Test buy follow-up",
    "testBuyInLocationString": "Test buy in {{location}}",
    "testbuyIsAlreadyLinkedStringDescriptionString": "This task is already linked to a Test buy.",
    "testBuyLostSalesExplanationString": "Test bought articles × price of the article. Ex: 1 × ‘Bekant’ (399EUR) failed Test buy = 399EUR in lost sales.",
    "testbuyNotAllArticlesTestedString": "Test buy cannot be completed until all articles have been tested and follow-up tasks created if needed.",
    "testbuyReassignedString": "Testbuy reassigned",
    "testBuysDoneInString": "Test buys done in {{ where }}",
    "testBuysDoneString": "Test buys done",
    "testBuysString": "Test buys",
    "testBuyString": "Test buy",
    "testBuyTaskString": "Test buy",
    "testBuyTypeString": "Type of Test buy",
    "testbuyV2EnabledDescriptionString": "To create a new Test buy, go to Home and tap the \"Test buy\" button.",
    "testbuyV2EnabledTitleString": "Test buys are now created from Home",
    "testbuyWillBeDeletedIfGoBackString": "This test buy will be deleted if you go back.",
    "testEnvironmentString": "QA ENVIRONMENT",
    "thankYouForFeedbackString": "Thank you for completing all the available feedback. Your input is helping to make Fixa a better experience for everyone <3",
    "thatsEverythingString": "That's everything",
    "thereWasAnIssueString": "There was an issue.",
    "theseUsersAlreadyExistString": "These users already exist and were not added: ",
    "theString": "the",
    "theTaskString": "the task",
    "thirdGroupingString": "Third grouping",
    "thirdString": "3rd",
    "thirdStringCapitalized": "Third",
    "thisArticleCanBeFoundInGroupString": "This article can be found in the group named '{{ groupName }}'",
    "thisIsRequiredString": "This is required",
    "thisTaskDoesNotExistString": "This task doesn’t seem to exist or may have been deleted.",
    "thisTaskString": "This task",
    "thisTaskTypeDoesNotExistString": "This task type doesn’t seem to exist or may have been deleted.",
    "thisTaskWillBeRepeatedEveryString": "This task will be repeated every",
    "thisTertialString": "This tertial",
    "thisWeekString": "This week",
    "thursdaysString": "Thursdays",
    "thursdayString": "Thursday",
    "thuString": "Thu",
    "tileNameInUpptackaString": "{{ tile }} in Upptäcka!",
    "titleAddString": "Add task title",
    "titleString": "Title",
    "todaysProgressString": "Today’s progress",
    "todaysTargetString": "Today’s target",
    "todayString": "Today",
    "todoBasicString": "Todo",
    "toDosString": "To-dos",
    "toggleAllString": "Toggle all",
    "tooLargeFilesErrorString": "One or more files are too large. Please select files that are smaller than {{ maxFileSize }}.",
    "toolTakenString": "Tool taken",
    "toolUpgradedString": "Tool upgraded",
    "tooManyArticlesAddedString": "Too many articles added.",
    "tooManyHfbsSelectedString": "Too many HFBs chosen, please remove {{count}}",
    "tooManyLinksErrorString": "You can add a maximum of {{maxLinks}} links",
    "top10String": "Top 10",
    "totalArticlesBoughtInString": "Total articles test bought done in {{ where }}",
    "totalArticlesBoughtString": "Total articles test bought done",
    "totalCapacityString": "Total capacity",
    "totalEstimatedTurnoverString": "Total Estimated Turnover",
    "totalEstTurnoverString": "Total refills (est. turnover)",
    "totalPiecesString": "Total Pieces",
    "totalRefillsPiecesString": "Total refills (pieces)",
    "totalRefillsString": "Total Refills",
    "totalString": "Total",
    "totalSumCashCarryString": "Total sum for Cash & Carry",
    "totalSumFailedTestBuysString": "Total sum of articles that failed Test buys",
    "totalSumPassedTestBuysString": "Total sum of passed Test buys",
    "totalSumString": "Total sum",
    "trainingString": "Training",
    "trolleyString": "Trolley",
    "tryAgainLaterMsg": "Please try again later.",
    "tryAgainString": "Try again",
    "trySearchingInString": "Try searching in “{{value}}”",
    "tuesdaysString": "Tuesdays",
    "tuesdayString": "Tuesday",
    "tueString": "Tue",
    "turnoverAceString": "Ace 1: Turnover",
    "turnoverContributionActionLabel": "View pieces",
    "turnoverContributionTitle": "Contribution (Turnover)",
    "turnoverString": "turnover",
    "TurnoverString": "Ace 1: Turnover",
    "tutorialTitleBodyString": "Learn how to use Fixa to the fullest!",
    "typeIn4TDigitCodeString": "Type in 4-digit PIN code.",
    "typeInPinToUnlockString": "Type your code",
    "typeOfArticlesString": "Type of articles",
    "typeOfTaskString": "Type of task",
    "unableToLoadSearch": "Unable to load search",
    "unauthorizedCountrySuperUserDisclaimerTitleString": "Are you a Country Super User?",
    "unauthorizedCoworkerDisclaimerTitleString": "Are you a Store Co-worker?",
    "unauthorizedDescriptionString": "Choose your role below to get started",
    "unauthorizedDisclaimerBodyString": "To get the necessary permissions to login to Fixa, please request access through My Identity.",
    "unauthorizedStoreSuperUserDisclaimerTitleString": "Are you a Store Super User?",
    "unauthorizedTeamsManagementDescriptionString": "Choose your role below to get started",
    "unauthorizedTeamsManagementTitleString": "Need to manage teams in Fixa?",
    "unauthorizedTitleString": "Need access to Fixa?",
    "undoneString": "Action undone.",
    "undoNotPossibleString": "You won't be able to undo this.",
    "undoString": "Undo",
    "unknownString": "Unknown",
    "unknownTeamString": "Unknown team",
    "unknownUserString": "unknown user",
    "unpublishedString": "Unpublished",
    "unpublishString": "Unpublish",
    "unsuallyHighNumber": "This is an unusually high number. Are you sure this is correct?",
    "unsupportedBrowserMessageString": "Please open this app in Chrome to get the supported user experience.",
    "unsupportedBrowserShortString": "Unsupported browser",
    "unsupportedBrowserTitleString": "Sorry, this browser is unsupported",
    "unsupportedBrowserYesButtonString": "Yes, show me how",
    "upcomingString": "Upcoming",
    "updateContactString": "Update store contact",
    "updateImagesAfterRemovingArticlesString": "Update images after removing articles",
    "updateLanguageString": "Update language",
    "updateMediaString": "Update media",
    "updateNameString": "Update {{ name }}",
    "updateNowExclamation": "Update now!",
    "updateProfileString": "Update profile",
    "updateString": "Update",
    "updateUnknownArticlesString": "Update Unknown articles",
    "updateUpptackaHomeScreenWithNewString": "Update upptäcka home screen with new {{ title }}",
    "updatingString": "Updating",
    "uploadFileString": "Upload File",
    "uploadImagesString": "Upload images",
    "uploadingString": "Uploading...",
    "uploadNewImagesString": "Upload new images",
    "uploadString": "Upload",
    "upptackaSetUpStep1String": "Tap 7 times in the top right corner to open the Admin panel",
    "upptackaSetUpStep2String": "Enter the password “{{ password }}”",
    "upptackaSetUpStep3String": "Change “In focus” to the new prefered option and confirm",
    "upptackaSetUpString": "Make sure to set it up in relevant areas in the store to help customers get the most out of the Upptäcka experience.",
    "useMultiOrderAddonsDescriptionString": "Use multi-order of add-ons to order refills for add-ons on the same location.",
    "userAlreadyAddedString": "This user has already been added.",
    "userAlreadyHasActiveTBString": "Selected user already has an active test buy. Please select another one.",
    "userBenefitsSubtitleString": "Gain some time with customers to support them in their <b>shopping experience</b>.",
    "userBenefitsTitleString": "Benefits of Fixa",
    "userGuideString": "User guide",
    "usersInString": "Users in",
    "usersInTeam": "Users: {{team}}",
    "usersString": "Users",
    "userStatus_ACTIVE": "Active",
    "userStatus_INACTIVE": "Inactive",
    "userString": "User",
    "userTaskFilterAllString": "All Tasks",
    "userTaskFilterCustomString": "Custom tasks",
    "userTaskFilterMFAQFollowUpString": "MFAQ follow up",
    "userTaskFilterPickAndRefillString": "Pick & Refill",
    "userTaskFilterProductString": "Product Issue",
    "userTaskFilterRecurringString": "Recurring",
    "userTaskFilterRefillString": "Refill",
    "userTaskFilterTestBuyFollowUpString": "Test buy follow up",
    "userYouString": "you",
    "useScannerPageString": "If you are using the RDT to scan articles, please use the scanner page.",
    "versionString": "Version {{ version }}",
    "viewAllString": "View all",
    "viewEstTurnoverString": "View turnover",
    "viewingString": "Viewing",
    "viewLostSalesString": "View lost sales",
    "viewMainTaskForDetailsString": "View main task for details",
    "viewOpenString": "View open tasks ",
    "viewPassedSalesString": "View passed sales",
    "viewPassRatioString": "View pass ratio",
    "viewPickedTaskString": "View",
    "viewPiecesString": "View pieces",
    "viewRankingString": "View ranking",
    "viewScheduleDetails": "View schedule details",
    "viewString": "view tasks",
    "viewSumPassedTestbuys": "View sum of passed Test buys",
    "voteCountString": "Count",
    "warehouseString": "Warehouse",
    "warningString": "Warning",
    "wasScheduledString": "This task was scheduled",
    "wednesdaysString": "Wednesdays",
    "wednesdayString": "Wednesday",
    "wedString": "Wed",
    "weekAbbreviationString": "w",
    "weekdayCannotBeDeselectedString": "{{weekday}} cannot be deselected as it is the weekday of the selected start date",
    "weeklyOnDaysString": "Weekly on {{days}}",
    "weeklyRecurrenceText": "Task will be scheduled to repeat once every {{interval}} {{week}} on <b>{{days}}</b>.",
    "weeklyRepeatingTaskSummaryText": "Task will be scheduled to repeat once every {{interval}} {{week}} on <b>{{days}}</b> starting <b>{{start}}</b> until <b>{{end}}</b>",
    "weeklyRepeatingTaskSummaryText2": "Task will be scheduled to repeat every week on <b>{{days}}</b> starting <b>{{start}}</b> until <b>{{end}}</b>",
    "weeklyRepeatString": "Every week on",
    "weeklyString": "Weekly",
    "weeksAgoString": "weeks ago",
    "weekString": "week",
    "weekString_plural": "weeks",
    "weekStringCapitalized": "Week",
    "weekString_other": "weeks",
    "weightString": "Weight",
    "whatHappensNextString": "What happens next?",
    "whatHaveYouDoneSoFarString": "What have you done so far?",
    "whatIsHomeString": "What is Home and Away?",
    "whatOtherActions": "What other actions have been taken?",
    "whatShouldTheCustomerExperienceString": "What should the customer experience",
    "whatsNextAfterCreatingTaskString": "After creating a task, you'll be able to write off articles (TT310) and print the P-tags.",
    "whatsNextDescriptionString": "After creating a task, you'll be able to write off articles (TT130) and print the P-tags.",
    "whatsNextString": "What's next?",
    "whatString": "What's the issue?",
    "whereCanIFindQT": "Where can I find...",
    "whereCanIfindString": "Where can I find the date stamp?",
    "whereCanIfindSupplierString": "Where can I find the supplier number?",
    "whereCanIFindTemplate": "Where can I find <b>{{subject}}</b>?",
    "whereCanIFindTemplateES": "Where can I find {{subject}}?",
    "whereToGetOutQT": "Where to get out",
    "whereWasQuestionAskedString": "Where was the question asked?",
    "whichIssueString": "{{ which }} issue",
    "wholeDivisionString": "Whole division",
    "wholeStoreString": "Whole store",
    "wholeStoreWithHfbsNotAllowedString": "Whole store and HFBs cannot be selected together",
    "WholeString": "Whole",
    "why2String": "Why are you closing the task?",
    "whyAreYouDroppingString": "Why are you dropping the task?",
    "whyAreYouEditingQuantityString": "Why are you editing the quantity?",
    "whyClosingTasksString": "Why are you closing the tasks?",
    "whyDroppingTasksString": "Why are you dropping the tasks?",
    "whyMediaNeedsToBeChangedString": "Why the media needs to be changed",
    "whyNotCreateATask": "Why not create a task?",
    "whyNotString": "Why not",
    "whyRUClosingString": "Why are you closing the task?",
    "whyString": "Why are you dropping the task?",
    "widthString": "Width",
    "withinStoreString": "Within store",
    "workBriefString": "Work brief",
    "writeOffArticlesWithSGFString": "Write off {{ count }} articles with SGF",
    "writeOffArticleWithSGFString": "Write off article with SGF",
    "wrongTypeString": "Wrong type",
    "yearsString": "years",
    "yearString": "year",
    "yellowBagString": "Yellow bag",
    "yellowBasketString": "Yellow basket",
    "yesDeleteCommentString": "Yes, delete comment",
    "yesString": "Yes",
    "yesterdayString": "Yesterday",
    "youAcceptedTheTask": "You accepted the task.",
    "youCannotDeleteThisTeamString": "You can not delete this team",
    "youCantAddMoreArticlesString": "You can’t add more articles.",
    "youClosedString": "You closed the task",
    "youDroppedString": "You dropped the task",
    "youHaveOngoingTaskDescriptionString": "All ongoing tasks will be closed.",
    "youHaveOngoingTaskString": "You have an ongoing task",
    "youHaveUnsavedChanges": "You have unsaved changes",
    "youNeedToCheckAllBoxesString": "You need to check all the checkboxes in order to complete.",
    "youReassignedString": "You reassigned the task",
    "youRejectedTheTask": "You rejected the task.",
    "youReleasedString": "You released the task",
    "yourPinCodeHasBeenSetUpString": "Your PIN code has been set up.",
    "yourPrevTeamDeactivatedString": "Your previous team was deactivated. Choose a team to continue.",
    "yourString": "Your team",
    "youString": "Just you here today",
    "youWillBeAskedForNewPinString": "You will be asked to set up you new PIN on your next login.",
    "youWillLoseAllDataSoFarString": "You will lose all data that you’ve entered so far.",
    "zeroNotLikelyString": "0 = Not at all likely",
    "zoomInAriaLabelString": "Zoom in",
    "zoomLevelAriaLabelString": "Current zoom level is {{zoomLevel}}%",
    "zoomOutAriaLabelString": "Zoom out"
  }
}